import AdAnalyticsTab from './AdAnalyticsTab';
import AdManagerTab from './AdManagerTab';
// GOVT WATCH disabled — Google Play policy "Misleading Claims / Missing Source Link for
// Government Information". Component + backend are intact; re-enable only with proper
// per-item source attribution. Search "GOVT WATCH disabled" for the other two sites.
// import GovtIntelligenceTab from './GovtIntelligenceTab';
import { useState, useEffect, useRef, useCallback } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'https://nethajiprime-backend.onrender.com';

// ── YouTube -> OTT catalog import (dry-run preview, then confirm) ────────────
function YouTubeImportPanel({ API_URL }) {
  const [loading, setLoading] = useState(false);
  const [dry, setDry] = useState(null);
  const [done, setDone] = useState(null);
  const [err, setErr] = useState('');
  const [removed, setRemoved] = useState(null);

  const catLine = (obj) => obj
    ? Object.entries(obj).sort((a, b) => b[1] - a[1]).map(([k, v]) => `${k}=${v}`).join(' · ')
    : '';

  const call = async (dryRun) => {
    setLoading(true); setErr('');
    try {
      const r = await fetch(`${API_URL}/api/import-youtube?dry_run=${dryRun}`, {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + (localStorage.getItem('token') || '') },
      });
      if (!r.ok) throw new Error('HTTP ' + r.status + ' — ' + (await r.text()).slice(0, 140));
      const d = await r.json();
      if (dryRun) { setDry(d); setDone(null); } else { setDone(d); }
      setRemoved(null);
    } catch (e) { setErr(e.message || 'Failed'); }
    setLoading(false);
  };

  const deleteAll = async () => {
    if (!window.confirm('Delete ALL imported YouTube videos from the catalog? Native uploads are not affected. This cannot be undone.')) return;
    setLoading(true); setErr('');
    try {
      const r = await fetch(`${API_URL}/api/import-youtube`, {
        method: 'DELETE',
        headers: { Authorization: 'Bearer ' + (localStorage.getItem('token') || '') },
      });
      if (!r.ok) throw new Error('HTTP ' + r.status + ' — ' + (await r.text()).slice(0, 140));
      const d = await r.json();
      setRemoved(d); setDry(null); setDone(null);
    } catch (e) { setErr(e.message || 'Failed'); }
    setLoading(false);
  };

  return (
    <div style={{ margin: '20px 0', background: 'rgba(204,0,0,0.05)', border: '1px solid rgba(204,0,0,0.3)', borderRadius: '12px', padding: '20px' }}>
      <div style={{ color: '#ff4444', fontWeight: 900, fontSize: '14px', marginBottom: '6px' }}>▶ IMPORT YOUTUBE VIDEOS</div>
      <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: '12px', marginBottom: '16px' }}>
        Imports recent uploads from Nethaji TV · NMK TV · Harichandra · Bharath TV into the catalog (deduped). Preview first, then confirm.
      </div>

      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '14px' }}>
        <button disabled={loading} onClick={() => call(true)}
          style={{ padding: '10px 20px', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,215,0,0.4)', borderRadius: '8px', color: '#FFD700', fontWeight: 900, cursor: loading ? 'default' : 'pointer', fontSize: '13px', opacity: loading ? 0.6 : 1 }}>
          🔍 PREVIEW (DRY RUN)
        </button>
        {dry && !done && (
          <button disabled={loading}
            onClick={() => { if (window.confirm(`Insert ${dry.new} videos into the catalog?`)) call(false); }}
            style={{ padding: '10px 20px', background: 'linear-gradient(135deg,#cc0000,#880000)', border: 'none', borderRadius: '8px', color: '#fff', fontWeight: 900, cursor: loading ? 'default' : 'pointer', fontSize: '13px', opacity: loading ? 0.6 : 1 }}>
            ✅ CONFIRM IMPORT ({dry.new})
          </button>
        )}
        <button disabled={loading} onClick={deleteAll} title="Undo — remove every imported YouTube video"
          style={{ padding: '10px 20px', background: 'transparent', border: '1px solid rgba(255,68,68,0.5)', borderRadius: '8px', color: '#ff6666', fontWeight: 900, cursor: loading ? 'default' : 'pointer', fontSize: '13px', opacity: loading ? 0.6 : 1, marginLeft: 'auto' }}>
          🗑️ DELETE ALL IMPORTED
        </button>
      </div>

      {loading && <div style={{ color: '#FFD700', fontSize: '12px', marginBottom: '10px' }}>⏳ Contacting YouTube + backend… this can take 1–2 minutes, please wait.</div>}
      {err && <div style={{ color: '#ff4444', fontSize: '12px', marginBottom: '10px' }}>❌ {err}</div>}

      {dry && !done && (
        <div style={{ background: 'rgba(0,0,0,0.3)', borderRadius: '8px', padding: '12px', fontSize: '12px', color: '#ddd' }}>
          <div style={{ color: '#FFD700', fontWeight: 800, marginBottom: '4px' }}>DRY RUN PREVIEW (nothing inserted)</div>
          <div>Fetched: <b>{dry.fetched}</b> · New (not yet imported): <b>{dry.new}</b></div>
          <div style={{ marginTop: '4px' }}>By category: {catLine(dry.by_category)}</div>
        </div>
      )}
      {done && (
        <div style={{ background: 'rgba(0,150,80,0.12)', border: '1px solid rgba(0,200,100,0.3)', borderRadius: '8px', padding: '12px', fontSize: '12px', color: '#cfe' }}>
          <div style={{ color: '#00cc88', fontWeight: 800, marginBottom: '4px' }}>✅ IMPORT COMPLETE</div>
          <div>Inserted: <b>{done.inserted}</b> of {done.new} new (fetched {done.fetched})</div>
          <div style={{ marginTop: '4px' }}>By category: {catLine(done.by_category)}</div>
        </div>
      )}
      {removed && (
        <div style={{ background: 'rgba(204,0,0,0.12)', border: '1px solid rgba(255,68,68,0.3)', borderRadius: '8px', padding: '12px', fontSize: '12px', color: '#fcc' }}>
          <div style={{ color: '#ff6666', fontWeight: 800, marginBottom: '4px' }}>🗑️ DELETE COMPLETE</div>
          <div>Removed <b>{removed.deleted}</b> imported YouTube videos from the catalog.</div>
        </div>
      )}
    </div>
  );
}


// ── NethajiPrime Playlist manager (admin) ────────────────────────────────────
function PlaylistManagerPanel({ API_URL }) {
  const GOLD = '#f5c842', MUTED = '#8a7060', GREEN = '#00d480', RED = '#ff4444';
  const auth = () => ({ Authorization: 'Bearer ' + (localStorage.getItem('token') || ''), 'Content-Type': 'application/json' });

  const [playlists, setPlaylists] = useState([]);
  const [sel, setSel] = useState(null);        // { playlist, episodes }
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  // import state
  const [impUrl, setImpUrl] = useState('');
  const [impName, setImpName] = useState('');
  const [preview, setPreview] = useState(null);
  // create state
  const [newName, setNewName] = useState('');
  const [newEmoji, setNewEmoji] = useState('📚');

  const loadPlaylists = useCallback(async () => {
    setErr('');
    try {
      const r = await fetch(`${API_URL}/api/playlists`);
      const d = await r.json();
      setPlaylists(d.playlists || []);
    } catch (e) { setErr('Load failed: ' + e.message); }
  }, [API_URL]);

  useEffect(() => { loadPlaylists(); }, [loadPlaylists]);

  const openPlaylist = async (id) => {
    setErr(''); setBusy(true);
    try {
      const r = await fetch(`${API_URL}/api/playlists/${id}`);
      const d = await r.json();
      setSel(d);
    } catch (e) { setErr('Open failed: ' + e.message); }
    setBusy(false);
  };

  const doImport = async (dry) => {
    if (!impUrl.trim()) { setErr('Paste a YouTube playlist URL'); return; }
    setErr(''); setBusy(true);
    try {
      const r = await fetch(`${API_URL}/api/import-youtube-playlist`, {
        method: 'POST', headers: auth(),
        body: JSON.stringify({ url: impUrl.trim(), name: impName.trim() || undefined, dry_run: dry }),
      });
      if (!r.ok) throw new Error('HTTP ' + r.status + ' — ' + (await r.text()).slice(0, 160));
      const d = await r.json();
      if (dry) { setPreview(d); }
      else { setPreview(null); setImpUrl(''); setImpName(''); await loadPlaylists(); alert(`Imported "${d.name}" — ${d.inserted} episodes.`); }
    } catch (e) { setErr(e.message || 'Import failed'); }
    setBusy(false);
  };

  const createPlaylist = async () => {
    if (!newName.trim()) { setErr('Name required'); return; }
    setErr(''); setBusy(true);
    try {
      const r = await fetch(`${API_URL}/api/playlists`, {
        method: 'POST', headers: auth(),
        body: JSON.stringify({ name: newName.trim(), emoji: newEmoji || '📚', display_order: playlists.length }),
      });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      setNewName(''); setNewEmoji('📚'); await loadPlaylists();
    } catch (e) { setErr(e.message || 'Create failed'); }
    setBusy(false);
  };

  const resync = async (id) => {
    setErr(''); setBusy(true);
    try {
      const r = await fetch(`${API_URL}/api/playlist/${id}/resync`, { method: 'POST', headers: auth() });
      if (!r.ok) throw new Error('HTTP ' + r.status + ' — ' + (await r.text()).slice(0, 160));
      const d = await r.json();
      alert(`Re-sync done: ${d.added} new episode(s) added.`);
      await openPlaylist(id); await loadPlaylists();
    } catch (e) { setErr(e.message || 'Re-sync failed'); }
    setBusy(false);
  };

  const toggleFeature = async (p) => {
    setBusy(true);
    try {
      await fetch(`${API_URL}/api/playlists/${p.id}/feature`, {
        method: 'POST', headers: auth(), body: JSON.stringify({ featured: !p.featured }),
      });
      await loadPlaylists();
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  const delPlaylist = async (id) => {
    if (!window.confirm('Delete this playlist and all its episodes? This cannot be undone.')) return;
    setBusy(true);
    try {
      await fetch(`${API_URL}/api/playlists/${id}`, { method: 'DELETE', headers: auth() });
      setSel(null); await loadPlaylists();
    } catch (e) { setErr(e.message); }
    setBusy(false);
  };

  const setEpisodeNumber = async (playlistId, item, n) => {
    try {
      await fetch(`${API_URL}/api/playlists/${playlistId}/items/${item.id}`, {
        method: 'PATCH', headers: auth(), body: JSON.stringify({ episode_number: n }),
      });
      await openPlaylist(playlistId);
    } catch (e) { setErr(e.message); }
  };

  const delItem = async (playlistId, itemId) => {
    try {
      await fetch(`${API_URL}/api/playlists/${playlistId}/items/${itemId}`, { method: 'DELETE', headers: auth() });
      await openPlaylist(playlistId);
    } catch (e) { setErr(e.message); }
  };

  const box = { background: 'rgba(0,0,0,0.3)', border: '1px solid rgba(212,168,67,0.2)', borderRadius: 10, padding: 16, marginBottom: 16 };
  const inp = { padding: '9px 12px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(212,168,67,0.3)', borderRadius: 8, color: '#fff', fontSize: 13 };
  const btn = (bg, fg) => ({ padding: '9px 16px', background: bg, border: 'none', borderRadius: 8, color: fg || '#000', fontWeight: 900, cursor: busy ? 'default' : 'pointer', fontSize: 12, opacity: busy ? 0.6 : 1 });

  return (
    <div style={{ margin: '20px 0' }}>
      <div style={{ color: GOLD, fontWeight: 900, fontSize: 15, marginBottom: 4 }}>📚 NETHAJIPRIME PLAYLISTS</div>
      <div style={{ color: MUTED, fontSize: 12, marginBottom: 16 }}>Import a YouTube playlist as a numbered series, or create one manually. Episodes play via YouTube embed.</div>
      {err && <div style={{ color: RED, fontSize: 12, marginBottom: 12 }}>❌ {err}</div>}

      {/* Import YouTube playlist */}
      <div style={box}>
        <div style={{ color: '#ff6666', fontWeight: 800, fontSize: 13, marginBottom: 10 }}>▶ IMPORT YOUTUBE PLAYLIST</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
          <input style={{ ...inp, flex: '2 1 320px' }} placeholder="YouTube playlist URL (…/playlist?list=PL…)" value={impUrl} onChange={e => setImpUrl(e.target.value)} />
          <input style={{ ...inp, flex: '1 1 160px' }} placeholder="Name (optional — uses YouTube title)" value={impName} onChange={e => setImpName(e.target.value)} />
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <button disabled={busy} style={btn('rgba(255,255,255,0.08)', GOLD)} onClick={() => doImport(true)}>🔍 PREVIEW</button>
          {preview && <button disabled={busy} style={btn('linear-gradient(135deg,#cc0000,#880000)', '#fff')} onClick={() => doImport(false)}>✅ CONFIRM IMPORT ({preview.count})</button>}
        </div>
        {busy && <div style={{ color: GOLD, fontSize: 12, marginTop: 10 }}>⏳ Contacting YouTube…</div>}
        {preview && (
          <div style={{ marginTop: 12, background: 'rgba(0,0,0,0.3)', borderRadius: 8, padding: 12, fontSize: 12, color: '#ddd', maxHeight: 220, overflowY: 'auto' }}>
            <div style={{ color: GOLD, fontWeight: 800, marginBottom: 6 }}>PREVIEW: {preview.name} — {preview.count} episodes</div>
            {(preview.episodes || []).map(ep => (
              <div key={ep.videoId} style={{ padding: '3px 0', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                <b>Ep {ep.episode_number}.</b> {ep.title}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Create empty playlist */}
      <div style={box}>
        <div style={{ color: GREEN, fontWeight: 800, fontSize: 13, marginBottom: 10 }}>＋ CREATE EMPTY PLAYLIST</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <input style={{ ...inp, width: 60, textAlign: 'center' }} value={newEmoji} onChange={e => setNewEmoji(e.target.value)} />
          <input style={{ ...inp, flex: '1 1 240px' }} placeholder="Playlist name" value={newName} onChange={e => setNewName(e.target.value)} />
          <button disabled={busy} style={btn(GREEN)} onClick={createPlaylist}>CREATE</button>
        </div>
      </div>

      {/* Existing playlists */}
      <div style={box}>
        <div style={{ color: GOLD, fontWeight: 800, fontSize: 13, marginBottom: 10 }}>EXISTING PLAYLISTS ({playlists.length})</div>
        {playlists.length === 0 && <div style={{ color: MUTED, fontSize: 12 }}>None yet — import or create one above.</div>}
        {playlists.map(p => (
          <div key={p.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid rgba(255,255,255,0.06)', flexWrap: 'wrap' }}>
            <span style={{ fontSize: 18 }}>{p.emoji || '📚'}</span>
            <span style={{ color: '#fff', fontWeight: 700, fontSize: 13, flex: '1 1 160px' }}>{p.name}</span>
            <span style={{ color: MUTED, fontSize: 11 }}>{p.episode_count} ep · order {p.display_order}{p.youtube_playlist_id ? ' · YT-linked' : ''}</span>
            <button style={btn('rgba(255,255,255,0.08)', GOLD)} onClick={() => openPlaylist(p.id)}>OPEN</button>
            <button style={btn(p.featured ? GOLD : 'rgba(255,255,255,0.08)', p.featured ? '#000' : GOLD)} onClick={() => toggleFeature(p)}>{p.featured ? '★ FEATURED' : '☆ FEATURE'}</button>
            {p.youtube_playlist_id && <button style={btn('rgba(255,255,255,0.08)', GOLD)} onClick={() => resync(p.id)}>↻ RESYNC</button>}
            <button style={btn('transparent', RED)} onClick={() => delPlaylist(p.id)}>🗑️</button>
          </div>
        ))}
      </div>

      {/* Selected playlist episodes */}
      {sel && sel.playlist && (
        <div style={box}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <div style={{ color: GOLD, fontWeight: 800, fontSize: 13 }}>{sel.playlist.emoji} {sel.playlist.name} — {(sel.episodes || []).length} episodes</div>
            <button style={btn('transparent', MUTED)} onClick={() => setSel(null)}>CLOSE</button>
          </div>
          {(sel.episodes || []).map(ep => (
            <div key={ep.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '6px 0', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
              <input type="number" defaultValue={ep.episode_number} style={{ ...inp, width: 60, padding: '5px 8px' }}
                onBlur={e => { const n = parseInt(e.target.value, 10); if (!isNaN(n) && n !== ep.episode_number) setEpisodeNumber(sel.playlist.id, ep, n); }} />
              {ep.thumbnail_url ? <img src={ep.thumbnail_url} alt="" style={{ width: 64, height: 36, objectFit: 'cover', borderRadius: 4 }} /> : null}
              <span style={{ color: '#fff', fontSize: 12, flex: 1 }}>{ep.title}</span>
              <span style={{ color: MUTED, fontSize: 10 }}>{ep.video_type}</span>
              <button style={btn('transparent', RED)} onClick={() => delItem(sel.playlist.id, ep.id)}>✕</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


function RevenueStats({ API_URL, token, showScheduler, setShowScheduler, schedMsg, setSchedMsg, schedTime, setSchedTime, schedStatus, setSchedStatus, isPaidMode, togglePaidMode }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [affStats, setAffStats] = useState(null);
  const [adRevenue, setAdRevenue] = useState(null);
  const [adsenseRevenue, setAdsenseRevenue] = useState(null);
  const [rev, setRev] = useState(null);
  const [revErr, setRevErr] = useState("");
  const [revGroup, setRevGroup] = useState("month");
  const [showAllTxns, setShowAllTxns] = useState(false);
  const [txnQuery, setTxnQuery] = useState("");

  useEffect(() => {
    fetch(API_URL + "/api/admin/user-stats", {headers: {Authorization: "Bearer " + token}})
      .then(r=>r.json())
      .then(data=>{ setStats(data); setLoading(false); })
      .catch(()=>setLoading(false));
    fetch(API_URL + "/api/admin/affiliate-stats", {headers: {Authorization: "Bearer " + token}})
      .then(r=>r.json())
      .then(data=>setAffStats(data))
      .catch(()=>{});
    fetch(API_URL + "/api/ads/revenue-summary", {headers: {Authorization: "Bearer " + token}})
      .then(r=>r.json())
      .then(data=>setAdRevenue(data))
      .catch(()=>{});
    fetch(API_URL + "/api/adsense/revenue", {headers: {Authorization: "Bearer " + token}})
      .then(r=>r.json())
      .then(data=>setAdsenseRevenue(data))
      .catch(()=>{});
  }, []);

  // Actual (not forecast) revenue, straight from paid rows.
  useEffect(() => {
    setRev(null); setRevErr("");
    fetch(API_URL + "/api/admin/revenue-stats?group=" + revGroup, {headers: {Authorization: "Bearer " + token}})
      .then(r => r.ok ? r.json() : r.json().then(d => Promise.reject(new Error(d.detail || ("HTTP " + r.status)))))
      .then(data => setRev(data))
      .catch(e => setRevErr(e.message || "Failed to load actual revenue"));
  }, [revGroup]);

  const fmtMoney = (v, cur) => {
    try {
      return new Intl.NumberFormat(cur === "INR" ? "en-IN" : "en-US",
        {style:"currency", currency: cur || "INR", maximumFractionDigits:2}).format(v || 0);
    } catch (e) { return (cur || "") + " " + (v || 0).toLocaleString(); }
  };

  // Supabase may hand back a naive timestamp; the backend writes UTC, so an
  // absent offset is treated as UTC rather than as browser-local time.
  const txnParts = (d, tz) => {
    const p = new Intl.DateTimeFormat("en-US", {timeZone: tz, day:"numeric", month:"short",
      hour:"numeric", minute:"2-digit", hour12:true}).formatToParts(d)
      .reduce((a, x) => { a[x.type] = x.value; return a; }, {});
    return {date: p.day + " " + p.month,
            time: p.hour + ":" + p.minute + " " + (p.dayPeriod || "").toUpperCase()};
  };

  const fmtWhen = (iso) => {
    if (!iso) return "\u2014";
    const hasTz = /(Z|[+-]\d{2}:?\d{2})$/.test(iso);
    const d = new Date(hasTz ? iso : iso + "Z");
    if (isNaN(d.getTime())) return "\u2014";
    try {
      const i = txnParts(d, "Asia/Kolkata");
      const u = txnParts(d, "UTC");
      return i.date + " " + i.time + " IST / " + u.time + " UTC";
    } catch (e) { return String(iso); }
  };

  const allTxnRows = ((rev && rev.all_transactions) || [])
    .filter(t => !txnQuery || String(t.name || "").toLowerCase().includes(txnQuery.toLowerCase()))
    .slice()
    .sort((a, b) => String(b.created_at || "").localeCompare(String(a.created_at || "")));

  if (loading) return <div style={{color:"#d4a843",padding:"40px",textAlign:"center"}}>Loading revenue data...</div>;
  if (!stats) return null;

  const monthly_subscription = (stats.paid_users || 0) * 149;
  // Real affiliate revenue: actual clicks * 3% conversion * avg order ₹450 * 5% commission
  const real_aff_clicks = affStats ? (affStats.total_clicks || 0) : 0;
  const est_monthly_clicks = real_aff_clicks * 30; // project monthly from current
  const monthly_affiliate = Math.round(est_monthly_clicks * 0.03 * 450 * 0.05);
  const monthly_political = 200000;
  const monthly_house_ads = adRevenue ? (adRevenue.total_monthly_revenue || 0) : 0;
  const monthly_adsense = adsenseRevenue ? (adsenseRevenue.total_monthly_revenue || 0) : 0;
  const total_monthly = monthly_subscription + monthly_affiliate + monthly_political + monthly_house_ads + monthly_adsense;
  // MoM growth projection
  const projected_3m = total_monthly * 1.3;
  const projected_6m = total_monthly * 1.8;

  return (
    <div style={{padding:"20px"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"20px",flexWrap:"wrap",gap:"10px"}}>
          <div style={{color:"#d4a843",fontWeight:900,fontSize:"18px"}}>💰 REVENUE DASHBOARD</div>
          <div style={{display:"flex",gap:"10px",alignItems:"center"}}>
            <div style={{display:"flex",alignItems:"center",gap:"10px",background:isPaidMode?"rgba(212,168,67,0.1)":"rgba(0,204,136,0.1)",border:"1px solid "+(isPaidMode?"rgba(212,168,67,0.4)":"rgba(0,204,136,0.4)"),borderRadius:"8px",padding:"8px 16px"}}>
              <span style={{color:isPaidMode?"#d4a843":"#00cc88",fontWeight:700,fontSize:"12px"}}>{isPaidMode?"💰 PAID MODE":"🎁 FREE MODE"}</span>
              <div onClick={togglePaidMode} style={{width:"44px",height:"24px",borderRadius:"12px",background:isPaidMode?"#d4a843":"#00cc88",cursor:"pointer",position:"relative",transition:"all 0.3s"}}>
                <div style={{position:"absolute",top:"3px",left:isPaidMode?"23px":"3px",width:"18px",height:"18px",borderRadius:"50%",background:"#fff",transition:"all 0.3s"}}></div>
              </div>
            </div>
            <button onClick={()=>setShowScheduler(!showScheduler)} style={{padding:'8px 16px',background:'rgba(153,0,204,0.15)',border:'1px solid rgba(153,0,204,0.4)',color:'#cc44ff',borderRadius:'6px',cursor:'pointer',fontWeight:'800',fontSize:'12px'}}>📅 SCHEDULE PUSH</button>
          </div>
        </div>
        {showScheduler && (
          <div style={{background:'rgba(153,0,204,0.08)',border:'1px solid rgba(153,0,204,0.3)',borderRadius:'12px',padding:'16px',marginBottom:'20px'}}>
            <div style={{color:'#cc44ff',fontWeight:900,fontSize:'13px',marginBottom:'12px'}}>📅 SCHEDULE PUSH NOTIFICATION</div>
            <input value={schedMsg} onChange={e=>setSchedMsg(e.target.value)} placeholder="Notification message..." style={{width:'100%',padding:'10px',background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',color:'#fff',marginBottom:'10px',boxSizing:'border-box'}}/>
            <input type="datetime-local" value={schedTime} onChange={e=>setSchedTime(e.target.value)} style={{width:'100%',padding:'10px',background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',color:'#fff',marginBottom:'10px',boxSizing:'border-box'}}/>
            {schedStatus && <div style={{color:schedStatus.includes('✅')?'#00cc88':'#ff4444',fontSize:'12px',marginBottom:'10px'}}>{schedStatus}</div>}
            <button onClick={async()=>{
              if(!schedMsg||!schedTime){setSchedStatus('❌ Fill all fields');return;}
              try{
                const tok=localStorage.getItem('token');
                const r=await fetch((window.API_URL||'https://nethajiprime-backend.onrender.com')+'/api/schedule-push',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+tok},body:JSON.stringify({message:schedMsg,scheduled_time:schedTime})});
                const d=await r.json();
                if(d.success){setSchedStatus('✅ Scheduled!');setSchedMsg('');setSchedTime('');}
                else setSchedStatus('❌ '+(d.error||'Failed'));
              }catch(e){setSchedStatus('❌ Error');}
            }} style={{padding:'10px 24px',background:'linear-gradient(135deg,#9900cc,#cc44ff)',border:'none',borderRadius:'8px',color:'#fff',fontWeight:900,cursor:'pointer',fontSize:'13px'}}>SCHEDULE</button>
          </div>
        )}
      
      {/* User Stats */}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(160px,1fr))",gap:"12px",marginBottom:"20px"}}>
        {[
          {label:"Total Users",value:stats.total_users,icon:"👥",color:"#0066cc"},
          {label:"Paid Users",value:stats.paid_users,icon:"💎",color:"#d4a843"},
          {label:"Free Users",value:stats.free_users,icon:"👤",color:"#888"},
          {label:"New Today",value:stats.new_today,icon:"🆕",color:"#00aa44"},
          {label:"Push Subscribers",value:stats.push_subscribers,icon:"🔔",color:"#ff6600"},
          {label:"Total Hypes",value:stats.total_hypes,icon:"🔥",color:"#cc0000"},
          {label:"Referrals",value:stats.total_referrals,icon:"📱",color:"#9900cc"},
          {label:"Conversion Rate",value:(stats.conversion_rate||0)+"%",icon:"📈",color:"#00cc88"},
        ].map(s=>(
          <div key={s.label} style={{background:"rgba(255,255,255,0.05)",border:"1px solid rgba(212,168,67,0.2)",borderRadius:"10px",padding:"14px",textAlign:"center"}}>
            <div style={{fontSize:"24px",marginBottom:"6px"}}>{s.icon}</div>
            <div style={{color:s.color,fontWeight:900,fontSize:"20px"}}>{s.value}</div>
            <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px"}}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* ACTUAL REVENUE - live from completed payments (Task 13 endpoint) */}
      <div style={{background:"rgba(0,204,136,0.05)",border:"1px solid rgba(0,204,136,0.3)",borderRadius:"12px",padding:"16px",marginBottom:"20px"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:"10px",marginBottom:"12px"}}>
          <div style={{color:"#00cc88",fontWeight:900,fontSize:"14px"}}>&#128176; ACTUAL REVENUE (LIVE PAYMENTS)</div>
          <div style={{display:"flex",gap:"6px"}}>
            {["day","week","month","year"].map(g=>(
              <button key={g} onClick={()=>setRevGroup(g)} style={{padding:"5px 12px",background:revGroup===g?"rgba(0,204,136,0.25)":"rgba(255,255,255,0.05)",border:"1px solid "+(revGroup===g?"rgba(0,204,136,0.6)":"rgba(255,255,255,0.1)"),color:revGroup===g?"#00cc88":"rgba(255,255,255,0.5)",borderRadius:"6px",cursor:"pointer",fontWeight:800,fontSize:"11px",textTransform:"uppercase"}}>{g}</button>
            ))}
          </div>
        </div>

        {revErr && <div style={{color:"#ff4444",fontSize:"12px"}}>&#9888; {revErr}</div>}
        {!rev && !revErr && <div style={{color:"rgba(255,255,255,0.4)",fontSize:"12px"}}>Loading actual revenue...</div>}

        {rev && rev.summary && (
        <div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(170px,1fr))",gap:"12px"}}>
            {[
              {label:"Total Revenue",value:fmtMoney(rev.summary.total_revenue,rev.summary.currency),color:"#00cc88"},
              {label:"Subscription Revenue",value:fmtMoney(rev.summary.subscription_revenue,rev.summary.currency),color:"#d4a843"},
              {label:"Donation Revenue",value:fmtMoney(rev.summary.donation_revenue,rev.summary.currency),color:"#ff6600"},
              {label:"Total Paid Subscriptions (lifetime)",value:rev.summary.paid_subscription_count,color:"#4499ff"},
              {label:"Currently Active",value:rev.summary.active_subscription_count,color:"#00aa44"},
              {label:"Donations",value:rev.summary.donation_count,color:"#cc88ff"},
            ].map(s=>(
              <div key={s.label} style={{background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.08)",borderRadius:"10px",padding:"14px",textAlign:"center"}}>
                <div style={{color:s.color,fontWeight:900,fontSize:"19px"}}>{s.value}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px",marginTop:"4px",lineHeight:1.3}}>{s.label}</div>
              </div>
            ))}
          </div>

          <div style={{color:"rgba(255,255,255,0.35)",fontSize:"10px",marginTop:"8px",lineHeight:1.5}}>
            Lifetime = every subscription ever paid for, including lapsed ones (this is what earned the revenue above).
            Currently Active = expires_at still in the future. Amounts shown in {rev.summary.currency}.
          </div>

          {rev.has_multi_currency && (
            <div style={{background:"rgba(255,170,0,0.1)",border:"1px solid rgba(255,170,0,0.35)",borderRadius:"8px",padding:"10px",marginTop:"12px",color:"#ffaa00",fontSize:"11px",lineHeight:1.5}}>
              &#9888; Multi-currency: the totals above are {rev.summary.currency} only and are never summed across currencies.
              All currencies seen: {(rev.currencies||[]).join(", ")}.
              Across every currency: {rev.active_subscription_count_all} currently active / {rev.paid_subscription_count_all} lifetime paid.
            </div>
          )}

          {rev.null_amount_subscriptions > 0 && (
            <div style={{background:"rgba(255,255,255,0.04)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:"8px",padding:"10px",marginTop:"10px",color:"rgba(255,255,255,0.5)",fontSize:"11px"}}>
              &#8505; {rev.null_amount_subscriptions} subscription row(s) have no amount stored and contribute 0 to the totals.
            </div>
          )}

          {rev.periods && rev.periods.length > 0 && (
            <div style={{marginTop:"16px"}}>
              <div style={{color:"rgba(255,255,255,0.55)",fontWeight:800,fontSize:"12px",marginBottom:"8px"}}>&#128200; BY {revGroup.toUpperCase()}</div>
              <div style={{overflowX:"auto"}}>
                <table style={{width:"100%",borderCollapse:"collapse",fontSize:"12px"}}>
                  <thead>
                    <tr style={{color:"rgba(255,255,255,0.4)"}}>
                      {["Period","Subscriptions","Donations","Total","Txns"].map(h=>(
                        <th key={h} style={{textAlign:"left",padding:"6px 8px",borderBottom:"1px solid rgba(255,255,255,0.1)",whiteSpace:"nowrap"}}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {rev.periods.slice(-12).reverse().map(p=>(
                      <tr key={p.period}>
                        <td style={{padding:"6px 8px",color:"#fff",whiteSpace:"nowrap"}}>{p.period}</td>
                        <td style={{padding:"6px 8px",color:"#d4a843",whiteSpace:"nowrap"}}>{fmtMoney(p.subscriptions,rev.summary.currency)}</td>
                        <td style={{padding:"6px 8px",color:"#ff6600",whiteSpace:"nowrap"}}>{fmtMoney(p.donations,rev.summary.currency)}</td>
                        <td style={{padding:"6px 8px",color:"#00cc88",fontWeight:800,whiteSpace:"nowrap"}}>{fmtMoney(p.total,rev.summary.currency)}</td>
                        <td style={{padding:"6px 8px",color:"rgba(255,255,255,0.5)"}}>{p.count}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {rev.recent_transactions && rev.recent_transactions.length > 0 && (
            <div style={{marginTop:"16px"}}>
              <div style={{color:"rgba(255,255,255,0.55)",fontWeight:800,fontSize:"12px",marginBottom:"8px"}}>&#129534; RECENT TRANSACTIONS</div>
              {rev.recent_transactions.map((t,i)=>(
                <div key={i} style={{display:"flex",justifyContent:"space-between",alignItems:"center",gap:"10px",padding:"7px 10px",background:"rgba(255,255,255,0.03)",borderRadius:"6px",marginBottom:"5px",fontSize:"12px"}}>
                  <span style={{minWidth:0,overflow:"hidden"}}>
                    <span style={{color:"rgba(255,255,255,0.75)",display:"block",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>
                      {t.type === "donation" ? "\u2764\ufe0f" : "\ud83d\udc8e"} {t.name}{t.plan ? " \u00b7 " + t.plan : ""}
                    </span>
                    <span style={{color:"rgba(255,255,255,0.35)",fontSize:"10px",whiteSpace:"nowrap"}}>{fmtWhen(t.created_at)}</span>
                  </span>
                  <span style={{color:"#00cc88",fontWeight:800,whiteSpace:"nowrap"}}>{fmtMoney(t.amount,t.currency)}</span>
                </div>
              ))}
            </div>
          )}

          {rev.all_transactions && rev.all_transactions.length > 0 && (
            <div style={{marginTop:"16px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:"10px"}}>
                <div onClick={()=>setShowAllTxns(!showAllTxns)} style={{color:"rgba(255,255,255,0.55)",fontWeight:800,fontSize:"12px",cursor:"pointer",userSelect:"none"}}>
                  {showAllTxns ? "\u25bc" : "\u25b6"} ALL TRANSACTIONS ({rev.all_transactions_total || rev.all_transactions.length})
                </div>
                {showAllTxns && (
                  <input value={txnQuery} onChange={e=>setTxnQuery(e.target.value)} placeholder="Search by name..."
                    style={{padding:"6px 10px",background:"rgba(255,255,255,0.05)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:"6px",color:"#fff",fontSize:"11px",minWidth:"170px"}}/>
                )}
              </div>

              {showAllTxns && (
                <div style={{marginTop:"10px"}}>
                  {rev.all_transactions_truncated && (
                    <div style={{background:"rgba(255,170,0,0.1)",border:"1px solid rgba(255,170,0,0.3)",borderRadius:"6px",padding:"8px 10px",marginBottom:"8px",color:"#ffaa00",fontSize:"11px"}}>
                      Showing the {rev.all_transactions.length} most recent of {rev.all_transactions_total}. Narrow the date range to reach older ones.
                    </div>
                  )}
                  <div style={{overflowX:"auto",maxHeight:"420px",overflowY:"auto"}}>
                    <table style={{width:"100%",borderCollapse:"collapse",fontSize:"12px"}}>
                      <thead>
                        <tr style={{color:"rgba(255,255,255,0.4)"}}>
                          {["Date / Time","Name","Type","Amount","Method","Currency"].map(h=>(
                            <th key={h} style={{textAlign:"left",padding:"6px 8px",borderBottom:"1px solid rgba(255,255,255,0.1)",whiteSpace:"nowrap",position:"sticky",top:0,background:"#14161a"}}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {allTxnRows.map((t,i)=>(
                          <tr key={i} style={{borderBottom:"1px solid rgba(255,255,255,0.04)"}}>
                            <td style={{padding:"6px 8px",whiteSpace:"nowrap",color:"rgba(255,255,255,0.8)"}}>{fmtWhen(t.created_at)}</td>
                            <td style={{padding:"6px 8px",color:"#fff",maxWidth:"180px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{t.name || "Anonymous"}</td>
                            <td style={{padding:"6px 8px",whiteSpace:"nowrap",color:t.type === "donation" ? "#ff6600" : "#d4a843"}}>{t.type || "unknown"}</td>
                            <td style={{padding:"6px 8px",whiteSpace:"nowrap",color:"#00cc88",fontWeight:800}}>{fmtMoney(t.amount,t.currency)}</td>
                            <td style={{padding:"6px 8px",whiteSpace:"nowrap",color:"rgba(255,255,255,0.6)"}}>{t.payment_method || "unknown"}</td>
                            <td style={{padding:"6px 8px",whiteSpace:"nowrap",color:"rgba(255,255,255,0.6)"}}>{t.currency || "INR"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {allTxnRows.length === 0 && (
                    <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px",padding:"10px 2px"}}>No transactions match "{txnQuery}".</div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
        )}
      </div>

      {/* Revenue Forecast */}
      <div style={{background:"rgba(212,168,67,0.05)",border:"1px solid rgba(212,168,67,0.3)",borderRadius:"12px",padding:"16px",marginBottom:"20px"}}>
        <div style={{color:"#d4a843",fontWeight:900,fontSize:"14px",marginBottom:"12px"}}>📊 MONTHLY REVENUE FORECAST</div>
        {[
          {label:"Subscription Revenue",value:"₹"+monthly_subscription.toLocaleString("en-IN"),color:"#d4a843",sub:(stats.paid_users||0)+" paid users × ₹149"},
          {label:"Affiliate Commission",value:"₹"+monthly_affiliate.toLocaleString("en-IN"),color:"#00aa44",sub:(affStats?affStats.total_clicks:"...")+" clicks tracked"},
          {label:"Political Campaigns",value:"₹"+monthly_political.toLocaleString("en-IN"),color:"#0066cc",sub:"fixed estimate"},
          {label:"Direct/House Ads",value:"₹"+monthly_house_ads.toLocaleString("en-IN"),color:"#d4a843",sub:(adRevenue?adRevenue.active_paying_ads:0)+" paying ads active"},
          {label:"Google AdSense",value:"₹"+monthly_adsense.toLocaleString("en-IN"),color:"#4285F4",sub:(adsenseRevenue&&adsenseRevenue.error)?"Pending approval":"Live from AdSense API"},
          {label:"TOTAL THIS MONTH",value:"₹"+total_monthly.toLocaleString("en-IN"),color:"#ff6600",bold:true},
          {label:"3-Month Projection",value:"₹"+Math.round(projected_3m).toLocaleString("en-IN"),color:"#cc88ff",sub:"+30% growth"},
          {label:"6-Month Projection",value:"₹"+Math.round(projected_6m).toLocaleString("en-IN"),color:"#ff88cc",sub:"+80% growth"},
        ].map(r=>(
          <div key={r.label} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:"1px solid rgba(255,255,255,0.05)"}}>
            <span style={{color:"rgba(255,255,255,0.6)",fontSize:"13px",fontWeight:r.bold?700:400}}>{r.label}{r.sub && <span style={{display:"block",color:"rgba(255,255,255,0.3)",fontSize:"10px"}}>{r.sub}</span>}</span>
            <span style={{color:r.color,fontWeight:900,fontSize:"13px"}}>{r.value}</span>
          </div>
        ))}
      </div>

      {/* Growth needed */}
      <div style={{background:"rgba(0,102,204,0.1)",border:"1px solid rgba(0,102,204,0.3)",borderRadius:"12px",padding:"16px"}}>
        <div style={{color:"#4499ff",fontWeight:900,fontSize:"14px",marginBottom:"12px"}}>🎯 GROWTH TARGETS</div>
        {[
          {target:"1,000 users",revenue:"₹1,49,000/month",current:stats.total_users,goal:1000},
          {target:"10,000 users",revenue:"₹14,90,000/month",current:stats.total_users,goal:10000},
          {target:"1,00,000 users",revenue:"₹1,49,00,000/month",current:stats.total_users,goal:100000},
        ].map(g=>(
          <div key={g.target} style={{marginBottom:"10px"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:"4px"}}>
              <span style={{color:"rgba(255,255,255,0.6)",fontSize:"12px"}}>{g.target} → {g.revenue}</span>
              <span style={{color:"#4499ff",fontSize:"12px"}}>{Math.min(100,Math.round((g.current||0)/g.goal*100))}%</span>
            </div>
            <div style={{background:"rgba(255,255,255,0.05)",borderRadius:"4px",height:"6px"}}>
              <div style={{background:"#0066cc",height:"100%",width:Math.min(100,Math.round((g.current||0)/g.goal*100))+"%",borderRadius:"4px"}}></div>
            </div>
          </div>
        ))}
      </div>
      {/* REVENUE SPLIT DASHBOARD - Step 29 */}
      <div style={{background:"rgba(255,255,255,0.03)",border:"1px solid rgba(212,168,67,0.2)",borderRadius:"12px",padding:"16px",marginTop:"20px"}}>
        <div style={{color:"#d4a843",fontWeight:900,fontSize:"14px",marginBottom:"16px"}}>📊 REVENUE SPLIT DASHBOARD</div>
        {(()=>{
          const sub = monthly_subscription;
          const aff = monthly_affiliate;
          const pol = monthly_political;
          const total = sub + aff + pol || 1;
          const items = [
            {label:"💎 Subscriptions",value:sub,color:"#d4a843",pct:Math.round(sub/total*100)},
            {label:"🔗 Affiliate",value:aff,color:"#00cc88",pct:Math.round(aff/total*100)},
            {label:"🏛️ Political",value:pol,color:"#4499ff",pct:Math.round(pol/total*100)},
          ];
          return (
            <div>
              {/* Bar chart */}
              <div style={{display:"flex",height:"32px",borderRadius:"8px",overflow:"hidden",marginBottom:"16px"}}>
                {items.map(item=>(
                  <div key={item.label} style={{width:item.pct+"%",background:item.color,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"10px",fontWeight:700,color:"#000",transition:"width 0.5s"}}>
                    {item.pct>10?item.pct+"%":""}
                  </div>
                ))}
              </div>
              {/* Legend */}
              {items.map(item=>(
                <div key={item.label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"8px 0",borderBottom:"1px solid rgba(255,255,255,0.05)"}}>
                  <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
                    <div style={{width:"12px",height:"12px",borderRadius:"3px",background:item.color}}></div>
                    <span style={{color:"rgba(255,255,255,0.7)",fontSize:"12px"}}>{item.label}</span>
                  </div>
                  <div style={{textAlign:"right"}}>
                    <span style={{color:item.color,fontWeight:700,fontSize:"13px"}}>₹{item.value.toLocaleString("en-IN")}</span>
                    <span style={{color:"rgba(255,255,255,0.3)",fontSize:"10px",marginLeft:"8px"}}>{item.pct}%</span>
                  </div>
                </div>
              ))}
              {/* Target */}
              <div style={{marginTop:"12px",padding:"10px",background:"rgba(212,168,67,0.05)",borderRadius:"8px",textAlign:"center"}}>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:"10px",marginBottom:"4px"}}>NEXT MILESTONE</div>
                <div style={{color:"#d4a843",fontWeight:900,fontSize:"14px"}}>
                  {total < 50000 ? "₹50,000/month — "+Math.round((50000-total)/149)+" more paid users needed" :
                   total < 100000 ? "₹1,00,000/month — "+Math.round((100000-total)/149)+" more paid users needed" :
                   "🎉 ₹1,00,000+ achieved!"}
                </div>
              </div>
            </div>
          );
        })()}
      </div>

      {affStats && (
        <div style={{background:"rgba(0,204,136,0.05)",border:"1px solid rgba(0,204,136,0.3)",borderRadius:"12px",padding:"16px",marginTop:"20px"}}>
          <div style={{color:"#00cc88",fontWeight:900,fontSize:"14px",marginBottom:"12px"}}>🔗 AFFILIATE ANALYTICS</div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"10px",marginBottom:"14px"}}>
            {[
              {label:"Total Clicks",value:affStats.total_clicks,color:"#00cc88"},
              {label:"Est. Conversions",value:affStats.est_conversions,color:"#d4a843"},
              {label:"Est. Revenue",value:"₹"+(affStats.est_revenue||0).toLocaleString("en-IN"),color:"#ff6600"},
            ].map(s=>(
              <div key={s.label} style={{background:"rgba(255,255,255,0.04)",borderRadius:"8px",padding:"12px",textAlign:"center"}}>
                <div style={{color:s.color,fontWeight:900,fontSize:"22px"}}>{s.value}</div>
                <div style={{color:"rgba(255,255,255,0.4)",fontSize:"11px",marginTop:"4px"}}>{s.label}</div>
              </div>
            ))}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
            <div>
              <div style={{color:"rgba(255,255,255,0.5)",fontSize:"11px",fontWeight:700,marginBottom:"6px"}}>BY STORE</div>
              {Object.entries(affStats.by_store||{}).sort((a,b)=>b[1]-a[1]).map(([store,cnt])=>(
                <div key={store} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid rgba(255,255,255,0.05)"}}>
                  <span style={{color:"rgba(255,255,255,0.6)",fontSize:"12px"}}>{store}</span>
                  <span style={{color:"#00cc88",fontWeight:700,fontSize:"12px"}}>{cnt} clicks</span>
                </div>
              ))}
            </div>
            <div>
              <div style={{color:"rgba(255,255,255,0.5)",fontSize:"11px",fontWeight:700,marginBottom:"6px"}}>BY CATEGORY</div>
              {Object.entries(affStats.by_category||{}).sort((a,b)=>b[1]-a[1]).map(([cat,cnt])=>(
                <div key={cat} style={{display:"flex",justifyContent:"space-between",padding:"4px 0",borderBottom:"1px solid rgba(255,255,255,0.05)"}}>
                  <span style={{color:"rgba(255,255,255,0.6)",fontSize:"12px"}}>{cat}</span>
                  <span style={{color:"#d4a843",fontWeight:700,fontSize:"12px"}}>{cnt} clicks</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// Phase 5: pick an existing series from a dropdown (so new episodes attach to a
// known id instead of a hand-typed one) or choose "New series" to type a fresh id.
function SeriesPicker({ value, onChange, list, disabled, inputStyle }) {
  const known = (value || '') !== '' && list.includes(value);
  const [isNew, setIsNew] = useState((value || '') !== '' && !known);
  const selectVal = isNew ? '__new__' : (value || '');
  return (
    <>
      <select style={inputStyle} disabled={disabled} value={selectVal}
        onChange={e => {
          const v = e.target.value;
          if (v === '__new__') { setIsNew(true); onChange(''); }
          else { setIsNew(false); onChange(v); }
        }}>
        <option value="">— None (standalone video) —</option>
        {list.map(s => <option key={s} value={s}>{s}</option>)}
        <option value="__new__">➕ New series…</option>
      </select>
      {isNew && (
        <input style={{ ...inputStyle, marginTop: '8px' }} type="text" value={value || ''} disabled={disabled}
          autoFocus placeholder="New series id, e.g. room-27"
          onChange={e => onChange(e.target.value)} />
      )}
    </>
  );
}

function AdminDashboard({ user, onLogout }) {
  const isSuperAdmin = user?.is_superadmin;
  const [activeTab, setActiveTab] = useState('upload');
  const [showScheduler, setShowScheduler] = useState(false);
  const [isPaidMode, setIsPaidMode] = useState(false);
  useEffect(() => {
    fetch(API_URL+'/api/app-settings')
      .then(r=>r.json())
      .then(d=>{ if(d.settings) setIsPaidMode(d.settings.is_paid_mode==='true'); })
      .catch(()=>{});
  }, []);
  const togglePaidMode = async () => {
    const newMode = !isPaidMode;
    const tok = localStorage.getItem('token');
    const r = await fetch(API_URL+'/api/app-settings', {
      method:'POST',
      headers:{'Content-Type':'application/json','Authorization':'Bearer '+tok},
      body:JSON.stringify({key:'is_paid_mode', value:newMode.toString()})
    });
    const d = await r.json();
    if(d.success) setIsPaidMode(newMode);
    else alert('Failed to update: '+d.error);
  };
  const [schedMsg, setSchedMsg] = useState('');
  const [schedTime, setSchedTime] = useState('');
  const [schedStatus, setSchedStatus] = useState('');
  const [pendingVideos, setPendingVideos] = useState([]);
  const [myVideos, setMyVideos] = useState([]);
  const [seriesFilter, setSeriesFilter] = useState('');   // '' = all; '__none__' = missing series_id; else an exact series_id
  const [seriesIdList, setSeriesIdList] = useState([]);   // Phase 5: existing series_ids for the upload/edit dropdown
  const [allComments, setAllComments] = useState([]);
  const [commentStats, setCommentStats] = useState({ pending: 0, approved: 0, rejected: 0, total: 0 });
  const [commentFilter, setCommentFilter] = useState('pending');
  const [loading, setLoading] = useState(true);
  const [analytics, setAnalytics] = useState(null);
  const [analyticsLoading, setAnalyticsLoading] = useState(false);
  const [analyticsError, setAnalyticsError] = useState('');   // Bug 2: surface the failure instead of swallowing it
  const [heatmap, setHeatmap] = useState({});
  const [completionStats, setCompletionStats] = useState(null);
  const [waData, setWaData] = useState(null);
  const [waLoading, setWaLoading] = useState(false);
  const [waFilter, setWaFilter] = useState('all');
  useEffect(() => {
    const tok = localStorage.getItem("token");
    if (tok) {
      fetch(API_URL+"/api/admin/completion-stats",{headers:{Authorization:"Bearer "+tok}})
        .then(r=>r.json()).then(d=>setCompletionStats(d)).catch(()=>{});
    }
    if (tok) fetch(API_URL+"/api/admin/retention-heatmap",{headers:{Authorization:"Bearer "+tok}}).then(r=>r.json()).then(d=>{ if(d.heatmap) setHeatmap(d.heatmap); }).catch(()=>{});
  }, []);
  const [videoFile, setVideoFile] = useState(null);
  const [videoPreviewUrl, setVideoPreviewUrl] = useState(null);
  // Source dimensions of the selected file, read from a throwaway <video>. Used
  // to decide whether an upload needs Bunny normalisation (see handleUpload).
  const [videoDims, setVideoDims] = useState(null);
  const videoPreviewRef = useRef(null);
  const [thumbFile, setThumbFile] = useState(null);
  const [thumbPreviewUrl, setThumbPreviewUrl] = useState(null);
  const [videoDetails, setVideoDetails] = useState({ title: '', description: '', speaker_name: '', category: 'Interviews', duration: 0, is_premium: false, is_reel: false, transcript: '', chapters: '', series_id: '', season_number: '', episode_number: '' });
  const [uploadProgress, setUploadProgress] = useState(0);
  const [seoLoading, setSeoLoading] = useState(false);
  const [fbReels, setFbReels] = useState([]);
  const [newReel, setNewReel] = useState({title:'',url:'',thumbnail_url:''});
  const [reelStatus, setReelStatus] = useState('');
  const fetchFbReels = async () => {
    const r = await fetch(API_URL+'/api/facebook-reels');
    const d = await r.json();
    if(d.reels) setFbReels(d.reels);
  };
  useEffect(()=>{ fetchFbReels(); },[]);
  const [uploadStatus, setUploadStatus] = useState('');
  const [uploading, setUploading] = useState(false);
  const generateSEO = async () => {
    if (!videoDetails.title) { alert('Enter a title first'); return; }
    setSeoLoading(true);
    try {
      const tok = localStorage.getItem('token');
      const response = await fetch(API_URL+'/api/generate-seo', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Authorization':'Bearer '+tok},
        body: JSON.stringify({title:videoDetails.title, speaker:videoDetails.speaker_name||'', category:videoDetails.category||''})
      });
      const data = await response.json();
      if (data.success) {
        const seoText = (data.keywords||[]).join(', ') + '\n\n' + (data.tamil_description||'');
        setVideoDetails(p => ({ ...p, description: seoText }));
      } else { alert('SEO failed: '+(data.error||'Unknown error')); }
    } catch(e) { alert('SEO generation failed: '+e.message); }
    setSeoLoading(false);
  };
  const [editingVideo, setEditingVideo] = useState(null);
  const [editDetails, setEditDetails] = useState({});
  const [editSaving, setEditSaving] = useState(false);
  const [editStatus, setEditStatus] = useState('');
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [userSearch, setUserSearch] = useState('');
  const [darkMode, setDarkMode] = useState(true);

  const today = new Date().toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  const bg0 = darkMode ? '#040000' : '#f5f0e8';
  const bgCard = darkMode ? 'linear-gradient(160deg,#1e0404,#0e0101)' : 'linear-gradient(160deg,#fff,#fdf5e6)';
  const textMain = darkMode ? '#f0e6cc' : '#1a0800';
  const gold = '#f5c842';
  const gold2 = '#d4a843';
  const red = '#cc0000';
  const red2 = '#880000';
  const cream = '#f0e6cc';
  const cream2 = '#c8b89a';
  const muted = '#8a7060';
  const green = '#00d480';
  const bg2 = '#0e0101';
  const border = 'rgba(212,168,67,0.18)';

  const CATS = [
    { v: 'Interviews', l: '🎙️ Interviews' },
    { v: 'Devotional', l: '🙏 Devotional' },
    { v: 'Stock Market', l: '📈 Stock Market' },
    { v: 'Astrology', l: '🔮 Astrology' },
    { v: 'Legal', l: '⚖️ Legal' },
    { v: 'Shorts', l: '⚡ Shorts' },
    { v: 'Reels', l: '🎞️ Reels' },
    { v: 'New', l: '🆕 New' },
    { v: 'Sun Detective', l: 'Sun Detective' },
    { v: 'Live News', l: 'Live News' },
    
    { v: 'Kids', l: 'Kids' },
    
    { v: 'Sports', l: 'Sports' },
    
    
    
    
    
    
    { v: 'Transport', l: 'Transport' },
    
    { v: 'Deals', l: 'Deals' },
    { v: 'Health', l: '🏥 Health' },
    { v: 'Kitchen', l: '🍳 Kitchen' },
  ];


  useEffect(() => {
    // Load admin data SEQUENTIALLY, not as a concurrent burst. Firing all of
    // these at once overwhelmed the small backend instance (EAGAIN / socket
    // exhaustion -> intermittent 500s). One-at-a-time trades a slightly slower
    // first paint for reliability. myVideos first so the library renders fast.
    (async () => {
      await fetchMyVideos();
      if (isSuperAdmin) {
        await fetchAnalytics();
        await fetchUsers();
        await fetchPendingVideos();
        await fetchCommentStats();
        await fetchAllComments();
      }
      await fetchSeriesIds();
      setLoading(false);
    })();
  }, []);

  const fetchUsers = async () => {
    setUsersLoading(true);
    try { const r = await fetch(API_URL + '/admin/users', { headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } }); const d = await r.json(); setUsers(d.users || []); } catch (e) {}
    setUsersLoading(false);
  };
  const handleToggleAdmin = async (userId, currentIsAdmin) => {
    if (!window.confirm((currentIsAdmin ? 'Remove admin from' : 'Make admin:') + ' this user?')) return;
    try {
      const r = await fetch(API_URL + '/admin/users/' + userId + '/toggle-admin', { method: 'PATCH', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token') }, body: JSON.stringify({ is_admin: !currentIsAdmin }) });
      if (r.ok) { fetchUsers(); }
      else { const e = await r.json(); alert('❌ ' + (e.detail || 'Failed')); }
    } catch (e) { alert('❌ ' + e.message); }
  };

  const token = () => localStorage.getItem('token');
  const authHeaders = () => ({ Authorization: 'Bearer ' + token() });
  const jsonHeaders = () => ({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + token() });

  const fetchPendingVideos = async () => {
    try { const r = await fetch(API_URL + '/admin/speeches/pending', { headers: authHeaders() }); const d = await r.json();
      const bunnyR = await fetch(API_URL + '/api/bunny/pending', { headers: authHeaders() });
      const bunnyD = await bunnyR.json();
      const allPending = [...(d.speeches || []), ...(bunnyD.shorts || []).map(s=>({...s, isBunnyShort: true}))];
      setPendingVideos(allPending); } catch (e) {}
  };
  const fetchMyVideos = async () => {
    try {
      const ep = isSuperAdmin ? '/admin/all-speeches' : '/admin/my-speeches';
      const r = await fetch(API_URL + ep, { headers: authHeaders() });
      const d = await r.json();
      const speeches = d.speeches || [];
      // Also fetch shorts
      const sr = await fetch(API_URL + '/admin/shorts', { headers: authHeaders() });
      const sd = await sr.json();
      const shorts = sd.shorts || [];
      const shortsFormatted = Array.isArray(shorts) ? shorts.map(s => ({
        ...s,
        video_url: s.bunny_url,
        thumbnail_url: s.thumbnail_url,
        category: 'Shorts',
        isBunnyShort: true
      })) : [];
      setMyVideos([...shortsFormatted, ...speeches]);
    } catch (e) {}
  };
  const fetchAllComments = async () => {
    try { const r = await fetch(API_URL + '/admin/comments/all', { headers: authHeaders() }); const d = await r.json(); setAllComments(d.comments || []); } catch (e) {}
  };
  const fetchSeriesIds = async () => {
    try { const r = await fetch(API_URL + '/admin/series-ids', { headers: authHeaders() }); const d = await r.json(); if (Array.isArray(d.series_ids)) setSeriesIdList(d.series_ids); } catch (e) {}
  };
  const fetchAnalytics = async () => {
    setAnalyticsLoading(true);
    setAnalyticsError('');
    try {
      const r = await fetch(API_URL + '/admin/analytics', { headers: authHeaders() });
      // TEMP DIAGNOSTIC (Bug 2): remove once the 0-counter cause is confirmed.
      console.log('[analytics] HTTP', r.status, r.statusText);
      let d = null;
      try { d = await r.json(); } catch (_) { d = null; }
      if (!r.ok) {
        const msg = (d && d.detail) ? d.detail : (r.status + ' ' + r.statusText);
        console.error('[analytics] request failed:', msg);
        setAnalyticsError('Analytics failed: ' + msg);
        setAnalytics(null);               // never store an error payload as if it were data
      } else if (!d || !d.overview) {
        console.error('[analytics] 200 but no overview field:', d);
        setAnalyticsError('Analytics returned no overview data.');
        setAnalytics(null);
      } else {
        setAnalytics(d);                  // only store a well-formed payload
      }
    } catch (e) {
      console.error('[analytics] network error:', e);
      setAnalyticsError('Analytics request error: ' + (e && e.message ? e.message : String(e)));
      setAnalytics(null);
    }
    setAnalyticsLoading(false);
  };
  const fetchCommentStats = async () => {
    try { const r = await fetch(API_URL + '/admin/comments/stats', { headers: authHeaders() }); const d = await r.json(); setCommentStats(d); } catch (e) {}
  };

  const handleVideoSelect = (e) => {
    const file = e.target.files[0]; if (!file) return;
    setVideoFile(file); setVideoPreviewUrl(URL.createObjectURL(file));
    const vid = document.createElement('video');
    vid.src = URL.createObjectURL(file);
    vid.muted = true;
    vid.playsInline = true;
    vid.onloadedmetadata = () => {
      setVideoDetails(p => ({ ...p, duration: Math.floor(vid.duration) }));
      setVideoDims({ width: vid.videoWidth || 0, height: vid.videoHeight || 0 });
      vid.currentTime = Math.min(3, vid.duration * 0.1);
    };
    vid.onseeked = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = vid.videoWidth || 1280;
        canvas.height = vid.videoHeight || 720;
        canvas.getContext('2d').drawImage(vid, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          if (blob) {
            const thumbF = new File([blob], 'auto-thumb.jpg', { type: 'image/jpeg' });
            setThumbFile(thumbF);
            setThumbPreviewUrl(URL.createObjectURL(thumbF));
          }
        }, 'image/jpeg', 0.85);
      } catch (err) { console.log('Thumb failed', err); }
    };
  };
  const handleCaptureThumb = () => { const v = videoPreviewRef.current; if (!v) return; const c = document.createElement('canvas'); c.width = v.videoWidth; c.height = v.videoHeight; c.getContext('2d').drawImage(v,0,0); c.toBlob(blob => { if(blob){ const f = new File([blob],'thumb.jpg',{type:'image/jpeg'}); setThumbFile(f); setThumbPreviewUrl(URL.createObjectURL(f)); }}, 'image/jpeg', 0.9); };
  const handleThumbSelect = (e) => { const f = e.target.files[0]; if (!f) return; setThumbFile(f); setThumbPreviewUrl(URL.createObjectURL(f)); };
  const handleClearVideo = () => { setVideoFile(null); setVideoPreviewUrl(null); setThumbFile(null); setThumbPreviewUrl(null); setVideoDetails(p => ({ ...p, duration: 0 })); };

  // A failed presign used to be destructured blind: uploadUrl came back
  // undefined, xhr.open('PUT', undefined) resolved against the page origin, and
  // the static host answered 405 - so an expired session looked like a broken
  // uploader. Fail loudly and name the actual cause instead.
  const presignOrThrow = async (res, what) => {
    if (res.status === 401 || res.status === 403) {
      throw new Error('Session expired — please log out and log in again, then retry the upload.');
    }
    if (!res.ok) {
      let detail = '';
      try { detail = (await res.clone().json()).detail || ''; } catch (e) { /* body not json */ }
      throw new Error(`Could not get an upload URL for the ${what} (HTTP ${res.status})${detail ? ' — ' + detail : ''}`);
    }
    const data = await res.json();
    if (!data.uploadUrl) {
      throw new Error(`Upload URL missing from the server response for the ${what}.`);
    }
    return data;
  };

  // Episode continuity: blank Series ID = standalone (all three NULL). If a
  // Series ID is given, Season + Episode are required. Throws so the caller's
  // try/catch surfaces the message in the upload/edit status line.
  const buildSeriesPayload = (d) => {
    const sid = (d.series_id || '').trim();
    if (!sid) return { series_id: null, season_number: null, episode_number: null };
    const s = parseInt(d.season_number, 10);
    const ep = parseInt(d.episode_number, 10);
    if (!(s >= 1) || !(ep >= 1)) throw new Error('Season and Episode are required (and must be ≥ 1) when Series ID is set');
    return { series_id: sid, season_number: s, episode_number: ep };
  };
  const handleUpload = async (e) => {
    e.preventDefault(); if (!videoFile) return;
    // Validate episode fields BEFORE any R2 upload so a bad Series/Season/Episode
    // combo fails fast instead of after a wasted upload.
    let series;
    try { series = buildSeriesPayload(videoDetails); }
    catch (err) { setUploadStatus('❌ ' + err.message); return; }
    setUploading(true); setUploadProgress(0); setUploadStatus('⏳ Starting upload...');
    // If category is Shorts - use Bunny.net and show in Watch Now
    if (videoDetails.category === 'Shorts') {
      try {
        setUploadStatus('🎬 Uploading to Bunny.net...');
        const formData = new FormData();
        formData.append('file', videoFile);
        formData.append('title', videoDetails.title);
        formData.append('language', 'ta');
        formData.append('genre', 'Shorts');
        formData.append('token', localStorage.getItem('token') || '');
        if (thumbFile) {
          formData.append('thumbnail', thumbFile);
        }
        const xhr = new XMLHttpRequest();
        xhr.upload.onprogress = (ev) => { if (ev.lengthComputable) setUploadProgress(Math.round((ev.loaded / ev.total) * 90)); };
        const bunnyResult = await new Promise((resolve, reject) => {
          xhr.open('POST', API_URL + '/api/bunny/upload');
          xhr.onload = () => resolve(JSON.parse(xhr.responseText));
          xhr.onerror = () => reject(new Error('Upload failed'));
          xhr.send(formData);
        });
        if (bunnyResult.success) {
          // Auto approve for admin
          await fetch(API_URL + '/admin/shorts', {
            method: 'PATCH',
            headers: jsonHeaders(),
            body: JSON.stringify({ bunny_video_id: bunnyResult.video_id, status: 'published' })
          });
          setUploadProgress(100);
          setUploadStatus('🎉 Published to Watch Now!');
          fetchMyVideos();
        } else {
          setUploadStatus('❌ Error: ' + bunnyResult.error);
        }
      } catch(err) {
        setUploadStatus('❌ Error: ' + err.message);
      }
      setUploading(false);
      return;
    }
    try {
      const ext = videoFile.name.split('.').pop();
      const videoKey = 'videos/' + Date.now() + '_' + videoDetails.title.replace(/[^a-z0-9]/gi, '_') + '.' + ext;
      setUploadStatus('📤 Getting upload URL...');
      const presignRes = await fetch(API_URL + '/admin/presign-upload', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ fileName: videoKey, contentType: videoFile.type }) });
      const { uploadUrl: upload_url, publicUrl: public_url } = await presignOrThrow(presignRes, 'video');
      setUploadStatus('🎬 Uploading video...');
      await new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        xhr.upload.onprogress = (ev) => { if (ev.lengthComputable) setUploadProgress(Math.round((ev.loaded / ev.total) * 80)); };
        xhr.onload = () => xhr.status === 200 ? resolve()
          : reject(new Error(`Storage rejected the upload (HTTP ${xhr.status}).`));
        xhr.onerror = reject;
        xhr.open('PUT', upload_url); xhr.setRequestHeader('Content-Type', videoFile.type); xhr.send(videoFile);
      });
      let thumbUrl = '';
      if (thumbFile) {
        setUploadStatus('🖼️ Uploading thumbnail...');
        const tExt = thumbFile.name.split('.').pop();
        const tKey = 'thumbnails/' + Date.now() + '_thumb.' + tExt;
        const tRes = await fetch(API_URL + '/admin/presign-upload', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify({ fileName: tKey, contentType: thumbFile.type }) });
        const { uploadUrl: tUrl, publicUrl: tPub } = await presignOrThrow(tRes, 'thumbnail');
        // Unchecked before: a failed thumbnail PUT still set thumbUrl, so the
        // video saved with a thumbnail_url pointing at nothing and rendered
        // blank in every grid with no error anywhere.
        const tPut = await fetch(tUrl, { method: 'PUT', headers: { 'Content-Type': thumbFile.type }, body: thumbFile });
        if (!tPut.ok) {
          throw new Error(
            `Thumbnail upload was rejected by storage (HTTP ${tPut.status}). `
            + `The video itself uploaded fine — retry with the thumbnail, or publish without one.`);
        }
        thumbUrl = tPub;
      }
      setUploadProgress(90); setUploadStatus('💾 Saving to database...');
      const chapters = videoDetails.chapters ? videoDetails.chapters.split('\n').filter(l => l.trim()).map(line => { const m = line.match(/^(\d+):(\d+)\s+(.+)$/); return m ? { time: parseInt(m[1]) * 60 + parseInt(m[2]), label: m[3].trim() } : null; }).filter(Boolean) : null;
      const speechPayload = { title: videoDetails.title, description: videoDetails.description || '', speaker_name: videoDetails.speaker_name, category: videoDetails.category, duration: parseInt(videoDetails.duration) || 0, video_url: public_url, thumbnail_url: thumbUrl || '', is_premium: videoDetails.is_premium, is_reel: videoDetails.is_reel, transcript: videoDetails.transcript || null, chapters, ...series };
      // Route non-conforming files (bigger than 720p, or over ~4 Mbps) through
      // Bunny Stream to transcode — they crash low-end Android decoders otherwise.
      // video_url carries the R2 original Bunny fetches; the row sits in
      // 'processing' until encoding finishes. Conforming files keep the instant
      // R2-direct publish below.
      const minDim = videoDims ? Math.min(videoDims.width, videoDims.height) : 0;
      const durSec = parseInt(videoDetails.duration) || 0;
      const bitrate = durSec > 0 ? (videoFile.size * 8) / durSec : 0;
      const needsNormalize = (minDim > 720) || (bitrate > 4000000);
      if (needsNormalize) {
        setUploadStatus('🛠️ Optimising for all devices…');
        const nres = await fetch(API_URL + '/admin/normalize-video', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify(speechPayload) });
        if (!nres.ok) {
          const err = await nres.json().catch(() => ({}));
          throw new Error(err.detail || 'Could not start optimisation. Please retry.');
        }
        setUploadProgress(100);
        setUploadStatus('⏳ Optimising video for all devices — it will publish automatically when encoding finishes. You can leave this page.');
        setVideoFile(null); setThumbFile(null); setVideoPreviewUrl(null); setThumbPreviewUrl(null); setVideoDims(null);
        setVideoDetails({ title: '', description: '', speaker_name: '', category: 'Interviews', duration: 0, is_premium: false, is_reel: false, transcript: '', chapters: '', series_id: '', season_number: '', episode_number: '' });
        fetchMyVideos(); if (isSuperAdmin) fetchPendingVideos();
        return;
      }
      const result = await fetch(API_URL + '/admin/speeches', { method: 'POST', headers: jsonHeaders(), body: JSON.stringify(speechPayload) });
      const resultData = await result.json();
      if (!result.ok) throw new Error(resultData.detail || ('Upload failed (HTTP ' + result.status + ')'));
      // Also save to shorts table for Watch Now
      if (resultData && resultData.id) {
        await fetch(API_URL + '/admin/shorts', {
          method: 'POST',
          headers: jsonHeaders(),
          body: JSON.stringify({
            title: videoDetails.title,
            thumbnail_url: thumbUrl || '',
            bunny_url: public_url,
            status: 'published',
            is_np_original: true,
            tags: [videoDetails.category]
          })
        });
      }
      setUploadProgress(100);
      setUploadStatus(resultData.approval_status === 'pending' ? '⏳ Submitted for approval!' : '🎉 Video published!');
      setVideoFile(null); setThumbFile(null); setVideoPreviewUrl(null); setThumbPreviewUrl(null);
      setVideoDetails({ title: '', description: '', speaker_name: '', category: 'Interviews', duration: 0, is_premium: false, is_reel: false, transcript: '', chapters: '', series_id: '', season_number: '', episode_number: '' });
      fetchMyVideos(); fetchSeriesIds(); if (isSuperAdmin) fetchPendingVideos();
    } catch (err) { setUploadStatus('❌ Error: ' + err.message); } finally { setUploading(false); }
  };

  const handleDeleteVideo = async (id, title, isBunny=false) => {
    if (!window.confirm('Delete "' + title + '"?')) return;
    try {
      if (isBunny) {
        await fetch(API_URL + '/api/bunny/delete/' + id, { method: 'DELETE', headers: authHeaders() });
      } else {
        await fetch(API_URL + '/admin/speeches/' + id, { method: 'DELETE', headers: authHeaders() });
      }
      alert('✅ Deleted!'); fetchMyVideos(); if (isSuperAdmin) fetchPendingVideos();
    } catch (e) { alert('❌ Error: ' + e.message); }
    try { const r = await fetch(API_URL + '/admin/speeches/' + id, { method: 'DELETE', headers: authHeaders() }); if (r.ok) { alert('? Deleted!'); fetchMyVideos(); if (isSuperAdmin) fetchPendingVideos(); } } catch (e) { alert('? Delete failed'); }
};
const handleBreaking = async (id, title) => {
  if (!window.confirm('Send BREAKING ALERT for: ' + title + '?')) return;
  try { const r = await fetch(API_URL + '/push/breaking?speech_id=' + id, { method: 'POST', headers: { Authorization: 'Bearer ' + localStorage.getItem('token') } }); const d = await r.json(); alert(d.message || '? Breaking alert sent!'); } catch(e) { alert('? Failed to send alert'); }
};
  // Phase 2 backfill: send one already-live video through Bunny. It stays live on
  // its current file until the encode finishes, then video_url swaps automatically.
  const handleNormalizeVideo = async (id, title) => {
    if (!window.confirm('Optimise "' + title + '" for all devices?\n\nIt stays live on its current file until encoding finishes, then swaps automatically.')) return;
    try {
      const r = await fetch(API_URL + '/admin/normalize-existing/' + id, { method: 'POST', headers: authHeaders() });
      const d = await r.json();
      if (r.ok) { alert('🛠️ ' + (d.message || 'Optimising started.')); fetchMyVideos(); }
      else { alert('❌ ' + (d.detail || 'Could not start optimisation.')); }
    } catch (e) { alert('❌ Error: ' + e.message); }
  };
  // Catalogue-wide backfill: dry-run the candidate count first, then kick off the
  // background pass (only videos larger than 720p, up to 100 per run).
  const handleNormalizeCatalogue = async () => {
    try {
      const cr = await fetch(API_URL + '/admin/normalize-candidates', { headers: authHeaders() });
      const cd = await cr.json();
      if (!cr.ok) { alert('❌ ' + (cd.detail || 'Could not list candidates.')); return; }
      if (!cd.count) { alert('✅ No videos need normalising.'); return; }
      if (!window.confirm(cd.count + ' videos are eligible.\n\nStart backfilling up to 100 (only those larger than 720p)? Each stays live until its encode finishes. Re-run to continue past 100.')) return;
      const r = await fetch(API_URL + '/admin/normalize-catalogue?limit=100&probe=true', { method: 'POST', headers: authHeaders() });
      const d = await r.json();
      if (r.ok) { alert('🛠️ ' + (d.note || 'Backfill started.') + '\n\nEnqueued ' + d.enqueued + ' of ' + d.total_candidates + ' candidates.'); fetchMyVideos(); }
      else { alert('❌ ' + (d.detail || 'Could not start backfill.')); }
    } catch (e) { alert('❌ Error: ' + e.message); }
  };
  // Reel-scoped backfill: normalise ALL reels (probe=false) to the lighter 720p/2800
  // MP4. Reels buffer heaviest in the app (ExoPlayer OOM), and buffer memory scales
  // with bitrate not resolution, so the >720p resolution probe is intentionally off.
  const handleNormalizeReels = async () => {
    try {
      const cr = await fetch(API_URL + '/admin/normalize-candidates?reels_only=true', { headers: authHeaders() });
      const cd = await cr.json();
      if (!cr.ok) { alert('❌ ' + (cd.detail || 'Could not list reel candidates.')); return; }
      if (!cd.count) { alert('✅ No reels need normalising.'); return; }
      if (!window.confirm(cd.count + ' reels are eligible.\n\nNormalise up to 100 (all of them, regardless of size)? Each stays live until its encode finishes. Re-run to continue past 100.')) return;
      const r = await fetch(API_URL + '/admin/normalize-catalogue?reels_only=true&probe=false&limit=100', { method: 'POST', headers: authHeaders() });
      const d = await r.json();
      if (r.ok) { alert('🛠️ ' + (d.note || 'Reel backfill started.') + '\n\nEnqueued ' + d.enqueued + ' of ' + d.total_candidates + ' reels.'); fetchMyVideos(); }
      else { alert('❌ ' + (d.detail || 'Could not start reel backfill.')); }
    } catch (e) { alert('❌ Error: ' + e.message); }
  };
  const handleRejectVideo = async (id, isBunny=false) => {
    if (!window.confirm('Reject this video?')) return;
    try {
      const url = isBunny
        ? API_URL + '/api/bunny/reject/' + id
        : API_URL + '/admin/speeches/' + id + '/reject';
      const method = isBunny ? 'PATCH' : 'POST';
      await fetch(url, { method: method, headers: authHeaders() });
      fetchPendingVideos(); fetchMyVideos();
      alert('Video rejected!');
    } catch (e) { alert('Error: ' + e.message); }
  };
  const handleApproveVideo = async (id, isBunny=false) => {
    try {
      const url = isBunny
        ? API_URL + '/api/bunny/approve/' + id
        : API_URL + '/admin/speeches/' + id + '/approve';
      const method = isBunny ? 'PATCH' : 'POST';
      await fetch(url, { method: method, headers: authHeaders() });
      fetchPendingVideos(); fetchMyVideos();
    } catch (e) {}
  };
  const handleApproveComment = async (id) => {
    try { await fetch(API_URL + '/admin/comments/' + id + '/approve', { method: 'PATCH', headers: authHeaders() }); fetchAllComments(); fetchCommentStats(); } catch (e) {}
  };
  const handleRejectComment = async (id) => {
    if (!window.confirm('Reject?')) return;
    try { await fetch(API_URL + '/admin/comments/' + id + '/reject', { method: 'PATCH', headers: authHeaders() }); fetchAllComments(); fetchCommentStats(); } catch (e) {}
  };
  const handleLogoutClick = () => { localStorage.removeItem('token'); localStorage.removeItem('user'); if (onLogout) onLogout(); else window.location.href = '/'; };
  const handleOpenEdit = async (video) => {
    setEditStatus('');
    // The list rows are lean (no description/transcript/chapters), and the edit
    // save is a full replace — so fetch the FULL row first and only open the
    // modal once we have it, otherwise a save would blank those fields.
    let v = video;
    try {
      const r = await fetch(API_URL + '/admin/speech/' + video.id, { headers: authHeaders() });
      if (r.ok) { const d = await r.json(); v = { ...video, ...(d.speech || {}) }; }
      else { alert('❌ Could not load full video details (HTTP ' + r.status + '). Try again.'); return; }
    } catch (e) { alert('❌ Could not load full video details: ' + (e && e.message ? e.message : e)); return; }
    setEditDetails({ title: v.title || '', description: v.description || '', speaker_name: v.speaker_name || '', category: v.category || 'Interviews', duration: v.duration || 0, is_premium: v.is_premium || false, transcript: v.transcript || '', chapters: v.chapters ? v.chapters.map(c => { const m = Math.floor(c.time / 60); const s = String(c.time % 60).padStart(2, '0'); return m + ':' + s + ' ' + c.label; }).join('\n') : '', series_id: v.series_id || '', season_number: v.season_number ?? '', episode_number: v.episode_number ?? '' });
    setEditingVideo(v);
  };
  const handleSaveEdit = async () => {
    if (!editingVideo) return; setEditSaving(true); setEditStatus('');
    try {
      const chapters = editDetails.chapters ? editDetails.chapters.split('\n').filter(l => l.trim()).map(line => { const m = line.match(/^(\d+):(\d+)\s+(.+)$/); return m ? { time: parseInt(m[1]) * 60 + parseInt(m[2]), label: m[3].trim() } : null; }).filter(Boolean) : null;
      const series = buildSeriesPayload(editDetails);
      const r = await fetch(API_URL + '/admin/speeches/' + editingVideo.id, { method: 'PATCH', headers: jsonHeaders(), body: JSON.stringify({ title: editDetails.title, description: editDetails.description || '', speaker_name: editDetails.speaker_name, category: editDetails.category || 'Interviews', duration: parseInt(editDetails.duration) || 0, video_url: editingVideo.video_url, thumbnail_url: editingVideo.thumbnail_url, is_premium: editDetails.is_premium, transcript: editDetails.transcript || null, chapters, ...series }) });
      if (r.ok) { setEditStatus('✅ Saved!'); fetchMyVideos(); fetchSeriesIds(); if (isSuperAdmin) fetchPendingVideos(); setTimeout(() => setEditingVideo(null), 800); }
      else { const err = await r.json(); setEditStatus('❌ ' + (err.detail || 'Failed')); }
    } catch (e) { setEditStatus('❌ ' + e.message); } finally { setEditSaving(false); }
  };
  const getFilteredComments = () => commentFilter === 'all' ? allComments : allComments.filter(c => c.status === commentFilter);
  const statusClr = (s) => s === 'approved' ? green : s === 'pending' ? '#ffa500' : s === 'processing' ? '#54b3d6' : s === 'failed' ? '#ff8c00' : '#ff4444';

  if (loading) return (
    <div style={{ background: '#040000', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ fontFamily: "'Cinzel', serif", color: gold, fontSize: '1.2em', letterSpacing: '4px' }}>LOADING...</div>
    </div>
  );

  const inputStyle = { width: '100%', padding: '11px 14px', background: '#1a0a00', border: '1px solid rgba(212,168,67,0.3)', borderRadius: '8px', color: '#f0e0c0', fontSize: '14px', fontFamily: "'Barlow', sans-serif", boxSizing: 'border-box', outline: 'none' };
  const labelStyle = { fontFamily: "'Barlow Condensed', sans-serif", fontSize: '10px', fontWeight: '800', letterSpacing: '2px', color: gold2, display: 'block', marginBottom: '6px' };
  const cardStyle = { background: bgCard, border: '1px solid rgba(212,168,67,0.18)', borderRadius: '12px', overflow: 'hidden', transition: 'all 0.3s' };
  const sectionHead = (eyebrow, title) => (
    <div style={{ marginBottom: '24px' }}>
      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '10px', fontWeight: '800', letterSpacing: '4px', color: gold2, marginBottom: '6px' }}>{eyebrow}</div>
      <h2 style={{ fontFamily: "'Cinzel', serif", fontSize: 'clamp(1.2em,2.5vw,1.8em)', fontWeight: '900', color: gold, letterSpacing: '2px', margin: 0 }}>{title}</h2>
      <div style={{ width: '50px', height: '2px', background: 'linear-gradient(90deg,' + gold + ',transparent)', marginTop: '8px' }} />
    </div>
  );

  // Bug 2: a metric the backend couldn't compute comes back null — render it as
  // "—" (unavailable), never 0, so a failed query can't masquerade as a real value.
  const mnum = (x) => (x === null || x === undefined) ? '—' : Number(x).toLocaleString();
  const failedMetrics = (analytics && Array.isArray(analytics.failed_metrics)) ? analytics.failed_metrics : [];

  // Bug 3: series filter over the content library ('' = all, '__none__' = missing, else exact series_id)
  const _seriesIds = Array.from(new Set(myVideos.map(v => v.series_id).filter(Boolean))).sort();
  // Dropdown source: union of the /admin/series-ids fetch AND the series_ids
  // already present in the loaded library — so an empty/failed fetch can't leave
  // the picker blank (which would force hand-typed ids and re-fragment series).
  const seriesOptions = Array.from(new Set([...(seriesIdList || []), ..._seriesIds])).sort();
  const filteredVideos = seriesFilter === ''
    ? myVideos
    : seriesFilter === '__none__'
      ? myVideos.filter(v => !v.series_id)
      : myVideos.filter(v => v.series_id === seriesFilter);

  return (
    <div style={{ background: bg0, minHeight: '100vh', color: textMain, fontFamily: "'Barlow', sans-serif", transition: 'background 0.3s' }}>

      {/* HEADER */}
      <header style={{ position: 'sticky', top: 0, zIndex: 200, background: 'rgba(4,0,0,0.97)', backdropFilter: 'blur(24px)', borderBottom: '1px solid ' + border, padding: '0 2%', minHeight: '56px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '14px' }}>
          <span style={{ fontFamily: "'Cinzel', serif", fontSize: '1.2em', fontWeight: '900', color: gold, letterSpacing: '4px', textShadow: '0 0 20px rgba(245,200,66,0.4)' }}>NETHAJI PRIME</span>
          <span style={{ padding: '4px 14px', borderRadius: '14px', background: isSuperAdmin ? 'rgba(212,168,67,0.15)' : 'rgba(204,0,0,0.15)', border: '1px solid ' + (isSuperAdmin ? gold2 : red), color: isSuperAdmin ? gold : '#ff6666', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: '800', letterSpacing: '2px' }}>
            {isSuperAdmin ? '👑 SUPERADMIN' : '📤 ADMIN'}
          </span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', color: muted, letterSpacing: '1px', display: 'flex', alignItems: 'center', gap: '6px' }}>
            <span style={{ color: gold2 }}>📅</span>{today}
          </span>
          <button onClick={() => setDarkMode(!darkMode)} title="Toggle theme" style={{ background: 'none', border: '1px solid rgba(212,168,67,0.3)', color: gold2, padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '14px' }}>
            {darkMode ? '☀️' : '🌙'}
          </button>
          <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', color: muted, letterSpacing: '1px', display: 'none' }}>{user?.full_name}</span>
          <button onClick={handleLogoutClick} style={{ background: 'none', border: '1px solid rgba(212,168,67,0.3)', color: gold2, padding: '6px 10px', borderRadius: '6px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: '700', letterSpacing: '1px' }}>← OUT</button>
        </div>
      </header>

      {/* ACTION BAR */}
      <div style={{ padding: '10px 3%', background: isSuperAdmin ? 'rgba(212,168,67,0.05)' : 'rgba(204,0,0,0.05)', borderBottom: '1px solid ' + (isSuperAdmin ? 'rgba(212,168,67,0.12)' : 'rgba(204,0,0,0.12)'), display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
        <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700', letterSpacing: '1.5px', color: isSuperAdmin ? gold2 : '#ff8888' }}>
          {isSuperAdmin ? '👑 SUPERADMIN — Upload, approve & moderate' : '📤 ADMIN — Upload videos for approval'}
        </span>
        {isSuperAdmin && (
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <button onClick={async () => { const r = await fetch(API_URL + '/admin/push/send', { method: 'POST', headers: authHeaders() }); if (r.ok) alert('✅ Push sent!'); }} style={{ padding: '6px 16px', background: 'rgba(0,168,225,0.15)', border: '1px solid rgba(0,168,225,0.4)', color: '#00a8e1', borderRadius: '6px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: '800', letterSpacing: '1px' }}>🔔 SEND PUSH</button>
            <button onClick={()=>window.open('https://nethajiprime.com/#nethajiq','_blank')} style={{padding:'6px 16px',background:'linear-gradient(135deg,#9900cc,#cc44ff)',border:'none',color:'#fff',borderRadius:'6px',cursor:'pointer',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'11px',fontWeight:'800',letterSpacing:'1px'}}>🧠⚡ NethajIQ</button>
            <button onClick={async()=>{
              if(!window.confirm('Run NethajIQ analytics refresh? This will analyze the last 90 days of YouTube data.')) return;
              const btn = document.activeElement;
              const orig = btn?.innerText;
              if(btn) btn.innerText = '⏳ Running...';
              try {
                const token = localStorage.getItem('token')||localStorage.getItem('jwt');
                const r = await fetch((process.env.REACT_APP_BACKEND_URL||"https://nethajiprime-backend.onrender.com")+'/api/nethajiq/refresh', {method:'POST',headers:{'Authorization':'Bearer '+token,'Content-Type':'application/json'},body:JSON.stringify({query:'refresh',query_type:'general'})});
                const d = await r.json();
                alert('✅ NethajIQ analytics refreshed!\n\n' + (d.message || JSON.stringify(d).slice(0,200)));
              } catch(e) {
                alert('❌ Error: ' + e.message);
              }
              if(btn) btn.innerText = orig;
            }} style={{padding:'6px 16px',background:'linear-gradient(135deg,#cc6600,#ff9933)',border:'none',color:'#fff',borderRadius:'6px',cursor:'pointer',fontFamily:"'Barlow Condensed',sans-serif",fontSize:'11px',fontWeight:'800',letterSpacing:'1px'}}>📊 Generate Stats (90d)</button>

            {showScheduler && (
              <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.8)',zIndex:99999,display:'flex',alignItems:'center',justifyContent:'center'}}>
                <div style={{background:'#1a1a2e',border:'1px solid rgba(153,0,204,0.4)',borderRadius:'12px',padding:'24px',width:'360px'}}>
                  <div style={{color:'#cc44ff',fontWeight:900,fontSize:'16px',marginBottom:'16px'}}>📅 SCHEDULE PUSH NOTIFICATION</div>
                  <input value={schedMsg} onChange={e=>setSchedMsg(e.target.value)} placeholder="Notification message..." style={{width:'100%',padding:'10px',background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',color:'#fff',marginBottom:'12px',boxSizing:'border-box'}}/>
                  <input type="datetime-local" value={schedTime} onChange={e=>setSchedTime(e.target.value)} style={{width:'100%',padding:'10px',background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',color:'#fff',marginBottom:'12px',boxSizing:'border-box'}}/>
                  {schedStatus && <div style={{color:schedStatus.includes('✅')?'#00cc88':'#ff4444',fontSize:'12px',marginBottom:'12px'}}>{schedStatus}</div>}
                  <div style={{display:'flex',gap:'10px'}}>
                    <button onClick={async()=>{
                      if(!schedMsg||!schedTime){setSchedStatus('❌ Fill all fields');return;}
                      try{
                        const r=await fetch(API_URL+'/api/schedule-push',{method:'POST',headers:{...authHeaders(),'Content-Type':'application/json'},body:JSON.stringify({message:schedMsg,scheduled_time:schedTime})});
                        const d=await r.json();
                        if(d.success){setSchedStatus('✅ Scheduled!');setSchedMsg('');setSchedTime('');}
                        else setSchedStatus('❌ '+(d.error||'Failed'));
                      }catch(e){setSchedStatus('❌ Error');}
                    }} style={{flex:1,padding:'10px',background:'linear-gradient(135deg,#9900cc,#cc44ff)',border:'none',borderRadius:'8px',color:'#fff',fontWeight:900,cursor:'pointer'}}>SCHEDULE</button>
                    <button onClick={()=>{setShowScheduler(false);setSchedStatus('');}} style={{padding:'10px 16px',background:'transparent',border:'1px solid rgba(255,255,255,0.2)',borderRadius:'8px',color:'#fff',cursor:'pointer'}}>Cancel</button>
                  </div>
                </div>
              </div>
            )}
            <button onClick={async () => { if (!window.confirm('Send weekly digest?')) return; const r = await fetch(API_URL + '/admin/digest/send', { method: 'POST', headers: authHeaders() }); const d = await r.json(); if (r.ok) alert('✅ Sent to ' + d.count + ' users!'); else alert('❌ Failed'); }} style={{ padding: '6px 16px', background: 'rgba(0,212,128,0.15)', border: '1px solid rgba(0,212,128,0.4)', color: green, borderRadius: '6px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: '800', letterSpacing: '1px' }}>📰 WEEKLY DIGEST</button>
          
          
          </div>
        )}
      </div>

      {/* STATS */}
      {isSuperAdmin && (analyticsError || failedMetrics.length > 0) && (
        <div style={{ padding: '10px 14px', background: 'rgba(255,0,0,0.08)', borderBottom: '1px solid rgba(255,0,0,0.3)', color: '#ff6b6b', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '13px', letterSpacing: '0.5px', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span>⚠️ {analyticsError || ('Some metrics unavailable: ' + failedMetrics.join(', '))}</span>
          <button onClick={fetchAnalytics} style={{ padding: '3px 10px', background: 'transparent', border: '1px solid rgba(255,107,107,0.5)', color: '#ff6b6b', borderRadius: '6px', cursor: 'pointer', fontSize: '11px' }}>RETRY</button>
        </div>
      )}
      {isSuperAdmin && analytics && (
        <div style={{ display: 'flex', gap: '0', borderBottom: '1px solid ' + border, overflowX: 'auto' }}>
          {[
            { icon: '🎬', label: 'VIDEOS', value: mnum(analytics.overview?.total_videos), color: gold2 },
            { icon: '👥', label: 'USERS', value: mnum(analytics.overview?.total_users), color: green },
            { icon: '👁️', label: 'VIEWS', value: mnum(analytics.overview?.total_views), color: '#00a8e1' },
            { icon: '👍', label: 'LIKES', value: mnum(analytics.overview?.total_likes), color: '#ff6b6b' },
            { icon: '🔥', label: 'HYPES', value: mnum(analytics.overview?.total_hypes), color: '#ff8c00' },
            { icon: '⏳', label: 'PENDING', value: pendingVideos.length, color: '#ffa500' },
            { icon: '💬', label: 'COMMENTS', value: commentStats.pending + ' pending', color: '#a78bfa' },
          ].map((s, i) => (
            <div key={i} style={{ flex: '0 0 auto', padding: '10px 14px', borderRight: '1px solid ' + border, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '3px', background: darkMode ? 'rgba(255,255,255,0.02)' : 'rgba(0,0,0,0.02)', minWidth: '70px' }}>
              <div style={{ fontFamily: "'Cinzel', serif", fontSize: '1.1em', fontWeight: '900', color: s.color }}>{s.value}</div>
              <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '9px', fontWeight: '800', letterSpacing: '2px', color: muted }}>{s.icon} {s.label}</div>
            </div>
          ))}
        </div>
      )}

      {/* TABS */}
      <div style={{ display: 'flex', gap: '4px', padding: '16px 3% 0', borderBottom: '1px solid ' + border, overflowX: 'auto' }}>
        {[
          { id: 'upload', label: '📤 UPLOAD' },
          { id: 'myvideos', label: '🎬 ' + (isSuperAdmin ? 'ALL' : 'MY') + ' VIDEOS (' + myVideos.length + ')' },
          ...(isSuperAdmin ? [
            { id: 'approvals', label: '✅ APPROVALS (' + pendingVideos.length + ')' },
            { id: 'playlists', label: '📚 PLAYLISTS' },
            { id: 'comments', label: '💬 COMMENTS (' + commentStats.pending + ')' },
            { id: 'analytics', label: '📊 ANALYTICS' },
            { id: 'users', label: '👥 USERS' },
            { id: 'revenue', label: '💰 REVENUE' },
            { id: 'ads', label: '📢 ADS' },
            { id: 'ad-analytics', label: '📊 AD ANALYTICS' },
            // GOVT WATCH disabled (Google Play policy) — see note at top of file.
            // { id: 'govt-intel', label: '🏛️ GOVT WATCH' },
          ] : []),
        ].map(t => (
          <button key={t.id} onClick={() => setActiveTab(t.id)} style={{ padding: '8px 12px', background: activeTab === t.id ? 'rgba(212,168,67,0.12)' : 'none', border: 'none', borderBottom: activeTab === t.id ? '2px solid ' + gold : '2px solid transparent', color: activeTab === t.id ? gold : muted, fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: '800', letterSpacing: '1px', cursor: 'pointer', whiteSpace: 'nowrap', transition: 'all 0.2s' }}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ padding: '16px 2%' }}>

        {/* UPLOAD TAB */}
        {activeTab === 'upload' && (
          <div style={{ maxWidth: '680px', margin: '0 auto' }}>
            {sectionHead('CONTENT MANAGEMENT', 'Upload New Video')}
            {!isSuperAdmin && <div style={{ background: 'rgba(255,140,0,0.08)', border: '1px solid rgba(255,140,0,0.3)', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px', color: '#ff8c00', fontSize: '13px' }}>⏳ Videos will be sent for superadmin approval.</div>}
            <div style={{ background: 'rgba(255,140,0,0.06)', border: '1px solid rgba(255,140,0,0.2)', borderRadius: '10px', padding: '12px 16px', marginBottom: '28px', fontSize: '13px', color: 'rgba(255,140,0,0.8)' }}>
              ⚠️ For iPhone audio: <code style={{ background: 'rgba(0,0,0,0.4)', padding: '2px 8px', borderRadius: '4px', color: gold2, fontSize: '12px' }}>ffmpeg -i video.mp4 -c:v copy -c:a aac -b:a 128k fixed.mp4</code>
            </div>

            <form onSubmit={handleUpload} style={{ display: 'flex', flexDirection: 'column', gap: '22px' }}>
              {/* Video */}
              <div>
                <label style={labelStyle}>🎬 VIDEO FILE (MP4) *</label>
                <div style={{ border: '2px dashed ' + (videoFile ? gold2 : 'rgba(212,168,67,0.25)'), borderRadius: '10px', padding: '20px', textAlign: 'center', background: 'rgba(212,168,67,0.03)' }}>
                  {videoFile ? (
                    <>
                      <p style={{ color: green, fontSize: '13px', marginBottom: '10px' }}>✅ {videoFile.name} ({(videoFile.size / 1024 / 1024).toFixed(1)} MB) — {videoDetails.duration}s</p>
                      <video ref={videoPreviewRef} src={videoPreviewUrl} controls style={{ width: '100%', maxHeight: '240px', borderRadius: '8px', marginBottom: '6px' }} />
                      <button type="button" onClick={handleCaptureThumb} style={{ padding: '6px 14px', background: 'rgba(212,168,67,0.1)', border: '1px solid rgba(212,168,67,0.3)', color: gold2, borderRadius: '8px', cursor: 'pointer', fontSize: '12px', marginBottom: '8px' }}>Capture Thumbnail</button>
                      <button type="button" onClick={handleClearVideo} style={{ padding: '6px 14px', background: 'rgba(200,0,0,0.1)', border: '1px solid rgba(200,0,0,0.35)', color: '#ff6666', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>✕ Remove</button>
                    </>
                  ) : (
                    <>
                      <div style={{ fontSize: '2.5em', marginBottom: '10px' }}>🎬</div>
                      <p style={{ color: muted, fontSize: '13px', marginBottom: '12px' }}>Click to select video file</p>
                      <input type="file" accept="video/*" onChange={handleVideoSelect} disabled={uploading} style={{ display: 'none' }} id="vid-input" />
                      <label htmlFor="vid-input" style={{ padding: '8px 20px', background: 'transparent', border: '1px solid rgba(212,168,67,0.3)', color: gold2, borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700' }}>Choose Video</label>
                    </>
                  )}
                </div>
              </div>

              {/* Thumbnail */}
              <div>
                <label style={labelStyle}>🖼️ THUMBNAIL IMAGE {thumbFile && thumbFile.name === 'auto-thumb.jpg' ? <span style={{ color: green, fontSize: '10px', marginLeft: '8px' }}>✅ AUTO-GENERATED</span> : <span style={{ color: muted, fontSize: '10px', marginLeft: '8px' }}>(auto-generated from video or choose manually)</span>}</label>
                <div style={{ border: '2px dashed ' + (thumbFile ? gold2 : 'rgba(212,168,67,0.25)'), borderRadius: '10px', padding: '16px', textAlign: 'center', background: 'rgba(212,168,67,0.03)' }}>
                  {thumbFile ? (
                    <>
                      <img src={thumbPreviewUrl} alt="thumb" style={{ width: '100%', maxHeight: '240px', objectFit: 'contain', borderRadius: '8px', marginBottom: '8px', background: '#0a0000' }} />
                      <p style={{ color: green, fontSize: '13px', marginBottom: '8px' }}>✅ {thumbFile.name}</p>
                      <input type="file" accept="image/*" onChange={handleThumbSelect} disabled={uploading} style={{ display: 'none' }} id="thumb-input" />
                      <label htmlFor="thumb-input" style={{ padding: '6px 16px', background: 'transparent', border: '1px solid rgba(212,168,67,0.3)', color: gold2, borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700' }}>Change Image</label>
                    </>
                  ) : (
                    <>
                      <div style={{ fontSize: '2em', marginBottom: '8px' }}>🖼️</div>
                      <p style={{ color: muted, fontSize: '12px', marginBottom: '8px' }}>Will auto-generate from video, or choose manually</p>
                      <input type="file" accept="image/*" onChange={handleThumbSelect} disabled={uploading} style={{ display: 'none' }} id="thumb-input" />
                      <label htmlFor="thumb-input" style={{ padding: '6px 16px', background: 'transparent', border: '1px solid rgba(212,168,67,0.3)', color: gold2, borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700' }}>Choose Image</label>
                    </>
                  )}
                </div>
              </div>

              {/* Fields */}
              {[
                { lbl: '📝 TITLE *', key: 'title', type: 'text', ph: 'Enter video title', req: true },

              ].map(f => (
                <div key={f.key}>
                  <label style={labelStyle}>{f.lbl}</label>
                  <input style={inputStyle} type={f.type} value={videoDetails[f.key]} onChange={e => setVideoDetails(p => ({ ...p, [f.key]: e.target.value }))} placeholder={f.ph} disabled={uploading} required={f.req} />
                </div>
              ))}

              {/* Category */}
              <div>
                <label style={labelStyle}>📁 CATEGORY</label>
                <select style={inputStyle} value={videoDetails.category} onChange={e => setVideoDetails(p => ({ ...p, category: e.target.value }))} disabled={uploading}>
                  {CATS.map(c => <option key={c.v} value={c.v}>{c.l}</option>)}
                </select>
              </div>

              {/* Duration */}
              <div>
                <label style={labelStyle}>⏱️ DURATION (seconds) — auto-detected</label>
                <input style={inputStyle} type="number" value={videoDetails.duration} onChange={e => setVideoDetails(p => ({ ...p, duration: parseInt(e.target.value) }))} disabled={uploading} />
              </div>

              {/* Content type */}
              <div>
                <label style={labelStyle}>⭐ CONTENT TYPE</label>
                <div style={{ display: 'flex', gap: '12px', marginTop: '4px' }}>
                  <button type="button" onClick={() => setVideoDetails(p => ({ ...p, is_premium: false }))} style={{ flex: 1, padding: '12px', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800', fontSize: '13px', letterSpacing: '1px', border: '2px solid rgba(0,212,128,0.4)', background: !videoDetails.is_premium ? 'rgba(0,212,128,0.15)' : 'transparent', color: !videoDetails.is_premium ? green : muted, transition: 'all 0.2s' }}>🆓 FREE</button>
                  <button type="button" onClick={() => setVideoDetails(p => ({ ...p, is_premium: true }))} style={{ flex: 1, padding: '12px', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800', fontSize: '13px', letterSpacing: '1px', border: '2px solid rgba(245,200,66,0.4)', background: videoDetails.is_premium ? 'rgba(245,200,66,0.12)' : 'transparent', color: videoDetails.is_premium ? gold : muted, transition: 'all 0.2s' }}>⭐ PREMIUM</button>
                </div>
              </div>

              {/* Reel format */}
              <div>
                <label style={labelStyle}>🎞️ REEL FORMAT</label>
                <div style={{ display: 'flex', gap: '12px', marginTop: '4px' }}>
                  <button type="button" onClick={() => setVideoDetails(p => ({ ...p, is_reel: false }))} style={{ flex: 1, padding: '12px', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800', fontSize: '13px', letterSpacing: '1px', border: '2px solid rgba(84,179,214,0.4)', background: !videoDetails.is_reel ? 'rgba(84,179,214,0.15)' : 'transparent', color: !videoDetails.is_reel ? '#54b3d6' : muted, transition: 'all 0.2s' }}>📺 STANDARD 16:9</button>
                  <button type="button" onClick={() => setVideoDetails(p => ({ ...p, is_reel: true }))} style={{ flex: 1, padding: '12px', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800', fontSize: '13px', letterSpacing: '1px', border: '2px solid rgba(204,0,204,0.4)', background: videoDetails.is_reel ? 'rgba(204,0,204,0.15)' : 'transparent', color: videoDetails.is_reel ? '#cc44ff' : muted, transition: 'all 0.2s' }}>🎞️ REEL (9:16)</button>
                </div>
              </div>

              {/* Episode continuity (optional) */}
              <div>
                <label style={labelStyle}>📺 SERIES / EPISODE — optional (leave Series ID blank for a standalone video)</label>
                <SeriesPicker value={videoDetails.series_id} list={seriesOptions} disabled={uploading} inputStyle={inputStyle}
                  onChange={v => setVideoDetails(p => ({ ...p, series_id: v }))} />
                {videoDetails.series_id.trim() && (
                  <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                    <div style={{ flex: 1 }}>
                      <label style={labelStyle}>SEASON *</label>
                      <input style={inputStyle} type="number" min="1" value={videoDetails.season_number} onChange={e => setVideoDetails(p => ({ ...p, season_number: e.target.value }))} placeholder="e.g. 1" disabled={uploading} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={labelStyle}>EPISODE *</label>
                      <input style={inputStyle} type="number" min="1" value={videoDetails.episode_number} onChange={e => setVideoDetails(p => ({ ...p, episode_number: e.target.value }))} placeholder="e.g. 1" disabled={uploading} />
                    </div>
                  </div>
                )}
              </div>

              {/* Description */}
              <div>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'4px'}}>
                  <label style={labelStyle}>📄 DESCRIPTION</label>
                  <button type="button" onClick={generateSEO} disabled={seoLoading||uploading} style={{padding:'4px 12px',background:'linear-gradient(135deg,#9900cc,#cc44ff)',border:'none',borderRadius:'6px',color:'#fff',fontSize:'10px',fontWeight:'800',cursor:'pointer',letterSpacing:'1px'}}>
                    {seoLoading ? '⏳ GENERATING...' : '🤖 GENERATE SEO'}
                  </button>
                </div>
                <textarea style={{ ...inputStyle, resize: 'vertical' }} value={videoDetails.description} onChange={e => setVideoDetails(p => ({ ...p, description: e.target.value }))} placeholder="Video description or click Generate SEO for Tamil keywords" rows="3" disabled={uploading} />
              </div>

              {/* Chapters */}
              <div>
                <label style={labelStyle}>⏱️ CHAPTERS (MM:SS Title per line)</label>
                <textarea style={{ ...inputStyle, fontFamily: 'monospace', resize: 'vertical' }} value={videoDetails.chapters} onChange={e => setVideoDetails(p => ({ ...p, chapters: e.target.value }))} placeholder={'0:00 Introduction\n2:30 Main Speech'} rows="4" disabled={uploading} />
              </div>

              {/* Transcript */}
              <div>
                <label style={labelStyle}>📝 TRANSCRIPT</label>
                <textarea style={{ ...inputStyle, resize: 'vertical' }} value={videoDetails.transcript} onChange={e => setVideoDetails(p => ({ ...p, transcript: e.target.value }))} placeholder="Full speech transcript..." rows="6" disabled={uploading} />
              </div>

              {/* Progress */}
              {uploading && (
                <div style={{ background: 'rgba(212,168,67,0.05)', border: '1px solid ' + border, borderRadius: '10px', padding: '16px' }}>
                  <p style={{ color: gold2, fontSize: '13px', marginBottom: '10px', fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '1px' }}>{uploadStatus}</p>
                  <div style={{ background: 'rgba(255,255,255,0.06)', borderRadius: '6px', height: '6px', overflow: 'hidden' }}>
                    <div style={{ width: uploadProgress + '%', height: '100%', background: 'linear-gradient(90deg,' + red + ',' + gold + ')', transition: 'width 0.3s', borderRadius: '6px' }} />
                  </div>
                  <p style={{ color: muted, fontSize: '12px', marginTop: '6px', textAlign: 'right' }}>{uploadProgress}%</p>
                </div>
              )}
              {!uploading && uploadStatus && (
                <div style={{ padding: '12px 16px', borderRadius: '8px', background: uploadStatus.includes('❌') ? 'rgba(255,68,68,0.08)' : 'rgba(0,212,128,0.08)', border: '1px solid ' + (uploadStatus.includes('❌') ? 'rgba(255,68,68,0.3)' : 'rgba(0,212,128,0.3)'), color: uploadStatus.includes('❌') ? '#ff6666' : green, fontSize: '13px' }}>
                  {uploadStatus}
                </div>
              )}

              <button type="submit" disabled={uploading || !videoFile} style={{ width: '100%', padding: '15px', background: 'linear-gradient(135deg,' + red + ',' + red2 + ')', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '15px', fontWeight: '900', letterSpacing: '3px', boxShadow: '0 6px 28px rgba(180,0,0,0.4)', opacity: (uploading || !videoFile) ? 0.6 : 1 }}>
                {uploading ? '⏳ UPLOADING...' : isSuperAdmin ? '🚀 UPLOAD & PUBLISH' : '📤 UPLOAD FOR APPROVAL'}
              </button>
            </form>
          </div>
        )}

        {/* FACEBOOK REELS MANAGER */}
        {activeTab === 'upload' && isSuperAdmin && (
          <div style={{margin:'20px 0',background:'rgba(24,119,242,0.05)',border:'1px solid rgba(24,119,242,0.3)',borderRadius:'12px',padding:'20px'}}>
            <div style={{color:'#1877f2',fontWeight:900,fontSize:'14px',marginBottom:'16px'}}>🎬 FACEBOOK REELS MANAGER</div>
            <div style={{display:'flex',flexDirection:'column',gap:'10px',marginBottom:'16px'}}>
              <input value={newReel.title} onChange={e=>setNewReel(p=>({...p,title:e.target.value}))} placeholder="Reel title..." style={{padding:'10px',background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',color:'#fff',fontSize:'13px'}}/>
              <input value={newReel.url} onChange={e=>setNewReel(p=>({...p,url:e.target.value}))} placeholder="Facebook Reel URL (https://www.facebook.com/reel/...)" style={{padding:'10px',background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',color:'#fff',fontSize:'13px'}}/>
              <input value={newReel.thumbnail_url} onChange={e=>setNewReel(p=>({...p,thumbnail_url:e.target.value}))} placeholder="Thumbnail image URL (optional)" style={{padding:'10px',background:'rgba(255,255,255,0.05)',border:'1px solid rgba(255,255,255,0.1)',borderRadius:'8px',color:'#fff',fontSize:'13px'}}/>
              {reelStatus && <div style={{color:reelStatus.includes('✅')?'#00cc88':'#ff4444',fontSize:'12px'}}>{reelStatus}</div>}
              <button onClick={async()=>{
                if(!newReel.title||!newReel.url){setReelStatus('❌ Title and URL required');return;}
                const tok=localStorage.getItem('token');
                const r=await fetch(API_URL+'/api/facebook-reels',{method:'POST',headers:{'Content-Type':'application/json','Authorization':'Bearer '+tok},body:JSON.stringify(newReel)});
                const d=await r.json();
                if(d.success){setReelStatus('✅ Reel added!');setNewReel({title:'',url:'',thumbnail_url:''});fetchFbReels();}
                else setReelStatus('❌ '+(d.error||'Failed'));
              }} style={{padding:'10px 24px',background:'linear-gradient(135deg,#1877f2,#0a5abf)',border:'none',borderRadius:'8px',color:'#fff',fontWeight:900,cursor:'pointer',fontSize:'13px'}}>➕ ADD REEL</button>
            </div>
            <div style={{maxHeight:'200px',overflowY:'auto'}}>
              {fbReels.map((reel,i)=>(
                <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
                  <div>
                    <div style={{color:'#fff',fontSize:'12px',fontWeight:600}}>{reel.title}</div>
                    <div style={{color:'rgba(255,255,255,0.3)',fontSize:'10px'}}>{reel.url?.substring(0,50)}...</div>
                  </div>
                  <button onClick={async()=>{
                    const tok=localStorage.getItem('token');
                    await fetch(API_URL+'/api/facebook-reels/'+reel.id,{method:'DELETE',headers:{Authorization:'Bearer '+tok}});
                    fetchFbReels();
                  }} style={{background:'rgba(255,68,68,0.1)',border:'1px solid rgba(255,68,68,0.3)',color:'#ff4444',borderRadius:'4px',padding:'4px 10px',cursor:'pointer',fontSize:'11px'}}>🗑️</button>
                </div>
              ))}
              {fbReels.length===0 && <div style={{color:'rgba(255,255,255,0.3)',fontSize:'12px',textAlign:'center',padding:'20px'}}>No reels added yet</div>}
            </div>
          </div>
        )}

        {/* YOUTUBE IMPORT */}
        {activeTab === 'upload' && isSuperAdmin && <YouTubeImportPanel API_URL={API_URL} />}

        {activeTab === 'playlists' && isSuperAdmin && <PlaylistManagerPanel API_URL={API_URL} />}

        {/* MY VIDEOS TAB */}
        {activeTab === 'myvideos' && (
          <div>
            {sectionHead('CONTENT LIBRARY', (isSuperAdmin ? 'All Videos' : 'My Videos') + ' (' + filteredVideos.length + (seriesFilter ? ' of ' + myVideos.length : '') + ')')}
            {/* Bug 3: series filter */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px', flexWrap: 'wrap' }}>
              <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: '800', letterSpacing: '2px', color: muted }}>SERIES</span>
              <select value={seriesFilter} onChange={e => setSeriesFilter(e.target.value)} style={{ padding: '7px 10px', background: darkMode ? 'rgba(255,255,255,0.05)' : '#fff', color: textMain, border: '1px solid ' + border, borderRadius: '8px', fontSize: '13px', maxWidth: '340px' }}>
                <option value="">All videos ({myVideos.length})</option>
                <option value="__none__">— no series_id — ({myVideos.filter(v => !v.series_id).length})</option>
                {_seriesIds.map(sid => (
                  <option key={sid} value={sid}>in series: {sid} ({myVideos.filter(v => v.series_id === sid).length})</option>
                ))}
              </select>
              {seriesFilter && <button onClick={() => setSeriesFilter('')} style={{ padding: '6px 12px', background: 'transparent', border: '1px solid ' + border, color: muted, borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>Clear</button>}
            </div>
            {isSuperAdmin && (
              <div style={{ marginBottom: '16px' }}>
                <button onClick={handleNormalizeCatalogue} style={{ padding: '9px 16px', background: 'rgba(84,179,214,0.12)', border: '1px solid rgba(84,179,214,0.4)', color: '#54b3d6', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700', letterSpacing: '1px', marginRight: '10px' }}>🛠️ NORMALISE CATALOGUE (&gt;720p)</button>
                <button onClick={handleNormalizeReels} style={{ padding: '9px 16px', background: 'rgba(245,200,66,0.12)', border: '1px solid rgba(245,200,66,0.4)', color: '#f5c842', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700', letterSpacing: '1px' }}>🎞️ NORMALISE REELS (all)</button>
              </div>
            )}
            {filteredVideos.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '60px', color: muted }}>
                <div style={{ fontSize: '3em', marginBottom: '16px' }}>🎬</div>
                <p style={{ fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '2px' }}>{seriesFilter ? 'NO VIDEOS MATCH THIS FILTER' : 'NO VIDEOS YET'}</p>
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(260px,1fr))', gap: '18px' }}>
                {filteredVideos.map(video => (
                  <div key={video.id} style={cardStyle}>
                    <div style={{ position: 'relative' }}>
                      {video.thumbnail_url ? <img src={video.thumbnail_url} alt={video.title} style={{ width: '100%', height: '150px', objectFit: 'cover' }} /> : <div style={{ width: '100%', height: '150px', background: '#180303', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2.5em' }}>🎬</div>}
                      {video.is_premium && <span style={{ position: 'absolute', top: '8px', right: '8px', background: 'rgba(245,200,66,0.9)', color: '#000', fontSize: '9px', fontWeight: '900', padding: '3px 8px', borderRadius: '10px', fontFamily: "'Barlow Condensed', sans-serif" }}>⭐ PREMIUM</span>}
                      <span style={{ position: 'absolute', bottom: '8px', left: '8px', background: statusClr(video.approval_status) + '22', color: statusClr(video.approval_status), border: '1px solid ' + statusClr(video.approval_status) + '66', fontSize: '10px', fontWeight: '700', padding: '2px 10px', borderRadius: '10px', fontFamily: "'Barlow Condensed', sans-serif" }}>
                        {video.approval_status === 'approved' ? '✅ LIVE' : video.approval_status === 'pending' ? '⏳ PENDING' : video.approval_status === 'processing' ? '🛠️ OPTIMISING' : video.approval_status === 'failed' ? '⚠️ ENCODE FAILED' : '❌ REJECTED'}
                      </span>
                    </div>
                    <div style={{ padding: '14px 16px' }}>
                      <h3 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '14px', fontWeight: '800', color: cream, lineHeight: '1.3', marginBottom: '6px' }}>{video.title}</h3>
                      <p style={{ color: muted, fontSize: '12px', margin: '2px 0' }}>🎤 {video.speaker_name}</p>
                      <p style={{ color: gold2, fontSize: '11px', margin: '2px 0', fontFamily: "'Barlow Condensed', sans-serif" }}>{video.category}</p>
                      {/* Bug 3: series_id / S / E — orange warning chip when missing, so it's easy to scan for */}
                      {video.series_id
                        ? <p style={{ color: '#54b3d6', fontSize: '11px', margin: '5px 0', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700 }}>📚 {video.series_id} · S{video.season_number ?? '–'}E{video.episode_number ?? '–'}</p>
                        : <p style={{ color: '#ff8c00', background: 'rgba(255,140,0,0.12)', border: '1px solid rgba(255,140,0,0.45)', borderRadius: '6px', padding: '2px 8px', display: 'inline-block', fontSize: '10px', margin: '5px 0', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 800, letterSpacing: '1px' }}>⚠ NO SERIES_ID</p>}
                      {video.video_url && <a href={video.video_url} target="_blank" rel="noreferrer" style={{ color: gold2, fontSize: '12px', textDecoration: 'none', display: 'inline-block', marginTop: '6px' }}>▶ Preview</a>}
                      <div style={{ display: 'flex', gap: '8px', marginTop: '12px' }}>
                <button onClick={() => handleOpenEdit(video)} style={{ flex: 1, padding: '8px', background: 'transparent', border: '1px solid rgba(212,168,67,0.3)', color: gold2, borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>Edit</button>
                <button onClick={()=>{if(window.confirm('Delete "'+video.title+'"? This cannot be undone.')){const B=(process.env.REACT_APP_BACKEND_URL||'https://nethajiprime-backend.onrender.com');const H={'Authorization':'Bearer '+localStorage.getItem('token')};Promise.allSettled([fetch(B+'/admin/speeches/'+video.id,{method:'DELETE',headers:H}),fetch(B+'/api/bunny/delete/'+video.id,{method:'DELETE',headers:H})]).then(()=>window.location.reload());}}} style={{padding:'8px 12px',background:'rgba(255,0,0,0.1)',border:'1px solid rgba(255,0,0,0.3)',color:'#ff4444',borderRadius:'8px',cursor:'pointer',fontSize:'12px'}}>Delete</button>
                {isSuperAdmin && video.approval_status === 'approved' && <button onClick={() => handleBreaking(video.id, video.title)} style={{ padding: '8px 12px', background: 'rgba(200,0,0,0.15)', border: '1px solid rgba(200,0,0,0.4)', color: '#ff4444', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>BREAKING</button>}
                {isSuperAdmin && video.video_url && !video.isBunnyShort && video.content_type !== 'youtube' && !String(video.video_url).includes('b-cdn.net') && !/youtube\.com|youtu\.be/.test(video.video_url) && (
                  video.normalize_status === 'processing'
                    ? <span style={{ padding: '8px 12px', color: '#54b3d6', fontSize: '12px', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700 }}>🛠️ Optimising…</span>
                    : <button onClick={() => handleNormalizeVideo(video.id, video.title)} style={{ padding: '8px 12px', background: 'rgba(84,179,214,0.12)', border: '1px solid rgba(84,179,214,0.4)', color: '#54b3d6', borderRadius: '8px', cursor: 'pointer', fontSize: '12px' }}>Normalise</button>
                )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* APPROVALS TAB */}
        {activeTab === 'approvals' && isSuperAdmin && (
          <div>
            {sectionHead('MODERATION', 'Pending Approvals (' + pendingVideos.length + ')')}
            {pendingVideos.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '60px', color: muted }}>
                <div style={{ fontSize: '3em', marginBottom: '16px' }}>🎉</div>
                <p style={{ fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '2px' }}>ALL CAUGHT UP!</p>
              </div>
            ) : (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(280px,1fr))', gap: '18px' }}>
                {pendingVideos.map(video => (
                  <div key={video.id} style={{ ...cardStyle, border: '1px solid rgba(255,165,0,0.2)' }}>
                    <div style={{ position: 'relative' }}>
                      {video.thumbnail_url ? <img src={video.thumbnail_url} alt={video.title} style={{ width: '100%', height: '150px', objectFit: 'cover' }} /> : <div style={{ width: '100%', height: '150px', background: '#180303', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '2.5em' }}>🎬</div>}
                    </div>
                    <div style={{ padding: '14px 16px' }}>
                      <h3 style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '14px', fontWeight: '800', color: cream, lineHeight: '1.3', marginBottom: '6px' }}>{video.title}</h3>
                      <p style={{ color: muted, fontSize: '12px', margin: '2px 0' }}>🎤 {video.speaker_name}</p>
                      <p style={{ color: gold2, fontSize: '11px', margin: '2px 0', fontFamily: "'Barlow Condensed', sans-serif" }}>{video.category}</p>
                      {video.video_url && <a href={video.video_url} target="_blank" rel="noreferrer" style={{ color: gold2, fontSize: '12px', textDecoration: 'none', display: 'inline-block', marginTop: '6px' }}>▶ Preview</a>}
                      <div style={{ display: 'flex', gap: '8px', marginTop: '12px', flexWrap: 'wrap' }}>
                        <button onClick={() => handleApproveVideo(video.id, video.isBunnyShort)} style={{ flex: 1, padding: '9px', background: 'rgba(0,212,128,0.1)', border: '1px solid rgba(0,212,128,0.35)', color: green, borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700' }}>✅ Approve</button>
                        <button onClick={() => handleRejectVideo(video.id, video.isBunnyShort)} style={{ flex: 1, padding: '9px', background: 'rgba(200,0,0,0.1)', border: '1px solid rgba(200,0,0,0.35)', color: '#ff6666', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700' }}>❌ Reject</button>
                        <button onClick={() => handleDeleteVideo(video.id, video.title, video.isBunnyShort)} style={{ width: '100%', padding: '7px', background: 'transparent', border: '1px solid rgba(200,0,0,0.25)', color: '#ff6666', borderRadius: '8px', cursor: 'pointer', fontSize: '11px', marginTop: '2px' }}>🗑️ Delete</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {/* COMMENTS TAB */}
        {activeTab === 'comments' && isSuperAdmin && (
          <div>
            {sectionHead('MODERATION', 'Comments')}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: '12px', marginBottom: '24px' }}>
              {[
                { l: '⏳ PENDING', v: commentStats.pending, c: '#ffa500' },
                { l: '✅ APPROVED', v: commentStats.approved, c: green },
                { l: '❌ REJECTED', v: commentStats.rejected, c: '#ff4444' },
                { l: '📊 TOTAL', v: commentStats.total, c: gold2 },
              ].map((s, i) => (
                <div key={i} style={{ background: 'linear-gradient(160deg,#1e0404,#0e0101)', border: '1px solid ' + s.c + '33', borderRadius: '12px', padding: '16px', textAlign: 'center' }}>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '10px', fontWeight: '700', letterSpacing: '2px', color: s.c, marginBottom: '8px' }}>{s.l}</div>
                  <div style={{ fontFamily: "'Cinzel', serif", fontSize: '1.8em', fontWeight: '900', color: s.c }}>{s.v}</div>
                </div>
              ))}
            </div>
            <div style={{ display: 'flex', gap: '8px', marginBottom: '20px', flexWrap: 'wrap' }}>
              {['pending', 'approved', 'rejected', 'all'].map(f => (
                <button key={f} onClick={() => setCommentFilter(f)} style={{ padding: '8px 20px', background: commentFilter === f ? 'rgba(212,168,67,0.15)' : 'transparent', border: '1px solid ' + (commentFilter === f ? gold2 : 'rgba(212,168,67,0.2)'), color: commentFilter === f ? gold : muted, borderRadius: '20px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700', letterSpacing: '1px' }}>
                  {f.toUpperCase()} ({f === 'all' ? commentStats.total : commentStats[f] || 0})
                </button>
              ))}
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {getFilteredComments().map(comment => (
                <div key={comment.id} style={{ background: 'linear-gradient(160deg,#1e0404,#0e0101)', border: '1px solid ' + statusClr(comment.status) + '33', borderRadius: '12px', padding: '16px 20px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', flexWrap: 'wrap', gap: '8px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <span style={{ fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800', color: cream, letterSpacing: '0.5px' }}>{comment.user_name}</span>
                      <span style={{ background: statusClr(comment.status) + '22', color: statusClr(comment.status), border: '1px solid ' + statusClr(comment.status) + '55', padding: '2px 10px', borderRadius: '10px', fontSize: '10px', fontWeight: '700', fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '1px' }}>{comment.status.toUpperCase()}</span>
                    </div>
                    <span style={{ color: muted, fontSize: '11px' }}>{new Date(comment.created_at).toLocaleString()}</span>
                  </div>
                  <p style={{ color: muted, fontSize: '12px', marginBottom: '8px', fontFamily: "'Barlow Condensed', sans-serif" }}>Video: <span style={{ color: gold2 }}>{comment.speeches?.title || 'Unknown'}</span></p>
                  <p style={{ color: cream2, fontSize: '14px', lineHeight: '1.5', fontStyle: 'italic', borderLeft: '3px solid ' + statusClr(comment.status) + '66', paddingLeft: '12px', margin: '8px 0 12px' }}>"{comment.comment_text}"</p>
                  {comment.status === 'pending' && (
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button onClick={() => handleApproveComment(comment.id)} style={{ padding: '7px 16px', background: 'rgba(0,212,128,0.1)', border: '1px solid rgba(0,212,128,0.35)', color: green, borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700' }}>✅ Approve</button>
                      <button onClick={() => handleRejectComment(comment.id)} style={{ padding: '7px 16px', background: 'rgba(200,0,0,0.1)', border: '1px solid rgba(200,0,0,0.35)', color: '#ff6666', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '700' }}>❌ Reject</button>
                    </div>
                  )}
                </div>
              ))}
              {getFilteredComments().length === 0 && <div style={{ textAlign: 'center', padding: '40px', color: muted, fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '2px' }}>NO {commentFilter.toUpperCase()} COMMENTS</div>}
            </div>
          </div>
        )}

        {/* ANALYTICS TAB */}
        {activeTab === 'analytics' && isSuperAdmin && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '28px', flexWrap: 'wrap', gap: '14px' }}>
              {sectionHead('PERFORMANCE', 'Analytics Dashboard')}
              <button onClick={fetchAnalytics} style={{ padding: '9px 20px', background: 'linear-gradient(135deg,' + gold2 + ',#b8922e)', border: 'none', color: '#000', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '900', letterSpacing: '1.5px' }}>🔄 REFRESH</button>
            </div>
            {analyticsLoading ? (
              <div style={{ textAlign: 'center', padding: '60px', color: muted, fontFamily: "'Barlow Condensed', sans-serif", letterSpacing: '2px' }}>LOADING...</div>
            ) : analytics ? (
              <>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: '14px', marginBottom: '28px' }}>
                  {[
                    { l: '🎬 Videos', v: mnum(analytics.overview?.total_videos), c: gold2, sub: 'total published' },
                    { l: '⏳ Pending', v: mnum(analytics.overview?.pending_videos), c: '#ffa500', sub: 'awaiting review' },
                    { l: '👥 Users', v: mnum(analytics.overview?.total_users), c: green, sub: 'registered' },
                    { l: '🆕 New (7d)', v: mnum(analytics.overview?.new_users_7days), c: green, sub: 'this week' },
                    { l: '👁️ Views', v: mnum(analytics.overview?.total_views), c: '#00a8e1', sub: 'total' },
                    { l: '👍 Likes', v: mnum(analytics.overview?.total_likes), c: '#ff6b6b', sub: 'total' },
                    { l: '🔥 Hypes', v: mnum(analytics.overview?.total_hypes), c: '#ff8c00', sub: 'total' },
                    { l: '💬 Comments', v: mnum(analytics.overview?.total_comments), c: '#a78bfa', sub: 'total' },
                    { l: '🔔 Subs', v: mnum(analytics.overview?.total_subscriptions), c: '#fbbf24', sub: 'active' },
                  ].map((s, i) => (
                    <div key={i} style={{ background: bgCard, border: '1px solid ' + s.c + '30', borderRadius: '12px', padding: '18px', textAlign: 'center' }}>
                      <div style={{ fontFamily: "'Cinzel', serif", fontSize: '1.7em', fontWeight: '900', color: s.c, marginBottom: '4px' }}>{(s.v||0)}</div>
                      <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '10px', fontWeight: '700', letterSpacing: '1.5px', color: s.c }}>{s.l}</div>
                      <div style={{ fontSize: '10px', color: muted, marginTop: '2px' }}>{s.sub}</div>
                    </div>
                  ))}
                </div>
                <div style={{ background: bgCard, border: '1px solid ' + border, borderRadius: '12px', padding: '22px' }}>
                  <div style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '800', letterSpacing: '3px', color: gold, marginBottom: '16px' }}>📋 ALL VIDEOS PERFORMANCE</div>
                  <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                      <thead>
                        <tr style={{ borderBottom: '1px solid ' + border }}>
                          {['#', 'Title', 'Speaker', 'Category', 'Views', 'Likes', 'Hypes', 'Type'].map(h => (
                            <th key={h} style={{ padding: '10px 12px', textAlign: 'left', color: gold2, fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800', letterSpacing: '1.5px', fontSize: '10px' }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {(analytics.all_videos||[]).sort((a,b)=>(b.views_count||0)-(a.views_count||0)).map((video, i) => (
                          <tr key={video.id} style={{ borderBottom: '1px solid rgba(212,168,67,0.06)', background: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)' }}>
                            <td style={{ padding: '10px 12px', color: muted }}>{i+1}</td>
                            <td style={{ padding: '10px 12px', color: textMain, maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{video.title}</td>
                            <td style={{ padding: '10px 12px', color: cream2 }}>{video.speaker_name}</td>
                            <td style={{ padding: '10px 12px', color: gold2 }}>{video.category}</td>
                            <td style={{ padding: '10px 12px', color: '#00a8e1', fontWeight: '700' }}>{(video.views_count||0).toLocaleString()}</td>
                            <td style={{ padding: '10px 12px', color: '#ff6b6b' }}>{video.like_count||0}</td>
                            <td style={{ padding: '10px 12px', color: '#ff8c00' }}>{video.hype_count||0}</td>
                            <td style={{ padding: '10px 12px' }}>
                              <span style={{ background: video.is_premium ? 'rgba(245,200,66,0.12)' : 'rgba(0,212,128,0.1)', color: video.is_premium ? gold : green, padding: '2px 10px', borderRadius: '10px', fontSize: '10px', fontWeight: '700' }}>
                                {video.is_premium ? '⭐ PREMIUM' : '🆓 FREE'}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            ) : (
              <div style={{ textAlign: 'center', padding: '60px', color: muted }}>No analytics data — click Refresh</div>
            )}
          </div>
        )}

        {/* VIDEO COMPLETION RATE */}
        {activeTab === 'analytics' && isSuperAdmin && completionStats && (
          <div style={{marginTop:'28px',background:'rgba(0,168,225,0.05)',border:'1px solid rgba(0,168,225,0.2)',borderRadius:'12px',padding:'20px'}}>
            <div style={{color:'#00a8e1',fontWeight:900,fontSize:'14px',marginBottom:'16px'}}>✅ VIDEO COMPLETION RATE — Top Videos Watched to End</div>
            <div style={{marginBottom:'12px',color:'rgba(255,255,255,0.5)',fontSize:'12px'}}>Total completions: <span style={{color:'#00a8e1',fontWeight:700}}>{completionStats.total_completions||0}</span></div>
            {(completionStats.top_videos||[]).map((v,i)=>(
              <div key={i} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'8px 0',borderBottom:'1px solid rgba(255,255,255,0.05)'}}>
                <span style={{color:'rgba(255,255,255,0.7)',fontSize:'12px',flex:1,marginRight:'12px'}}>{i+1}. {v.title}</span>
                <span style={{color:'#00a8e1',fontWeight:700,fontSize:'12px',whiteSpace:'nowrap'}}>{v.completions} completed</span>
              </div>
            ))}
            {(!completionStats.top_videos||completionStats.top_videos.length===0) && (
              <div style={{color:'rgba(255,255,255,0.3)',fontSize:'12px'}}>No completions tracked yet — data appears when users watch 90%+ of a video.</div>
            )}
          </div>
        )}

        {/* RETENTION HEATMAP */}
        {activeTab === 'analytics' && isSuperAdmin && (
          <div style={{marginTop:'28px',background:'rgba(255,255,255,0.03)',border:'1px solid rgba(212,168,67,0.2)',borderRadius:'12px',padding:'20px'}}>
            <div style={{color:'#d4a843',fontWeight:900,fontSize:'14px',marginBottom:'16px'}}>🔥 USER ACTIVITY HEATMAP (Hour vs Day)</div>
            <div style={{overflowX:'auto'}}>
              <table style={{borderCollapse:'collapse',width:'100%',fontSize:'11px'}}>
                <thead>
                  <tr>
                    <th style={{color:'rgba(255,255,255,0.4)',padding:'4px 8px',textAlign:'left'}}>Hour</th>
                    {['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].map(d=>(
                      <th key={d} style={{color:'rgba(255,255,255,0.4)',padding:'4px 8px',textAlign:'center'}}>{d}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {Array.from({length:24},(_,h)=>(
                    <tr key={h}>
                      <td style={{color:'rgba(255,255,255,0.3)',padding:'3px 8px'}}>{h}:00</td>
                      {Array.from({length:7},(_,d)=>{
                        const val=heatmap[d+'_'+h]||0;
                        const max=Math.max(...Object.values(heatmap),1);
                        const intensity=val/max;
                        return (
                          <td key={d} style={{padding:'3px 8px',textAlign:'center',background:val>0?`rgba(212,168,67,${intensity.toFixed(2)})`:'transparent',borderRadius:'3px',color:intensity>0.5?'#000':'rgba(255,255,255,0.5)',fontSize:'10px'}}>
                            {val>0?val:''}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* USERS TAB */}
        
        {/* AD MANAGER TAB */}
        {activeTab === 'ads' && isSuperAdmin && <AdManagerTab backendUrl={API_URL} token={localStorage.getItem("token") || localStorage.getItem("jwt") || ""} />}
        {activeTab === 'ad-analytics' && isSuperAdmin && <AdAnalyticsTab backendUrl={API_URL} token={localStorage.getItem("token") || localStorage.getItem("jwt") || ""} />}
        {/* GOVT WATCH disabled (Google Play policy) — see note at top of file.
        {activeTab === 'govt-intel' && isSuperAdmin && <GovtIntelligenceTab backendUrl={API_URL} token={localStorage.getItem("token") || localStorage.getItem("jwt") || ""} />} */}

        {activeTab === 'revenue' && isSuperAdmin && (
        <RevenueStats API_URL={API_URL} token={localStorage.getItem('token')} showScheduler={showScheduler} setShowScheduler={setShowScheduler} schedMsg={schedMsg} setSchedMsg={setSchedMsg} schedTime={schedTime} setSchedTime={setSchedTime} schedStatus={schedStatus} setSchedStatus={setSchedStatus} isPaidMode={isPaidMode} togglePaidMode={togglePaidMode} />
      )}

      {activeTab === 'users' && isSuperAdmin && (
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '24px', flexWrap: 'wrap', gap: '14px' }}>
              {sectionHead('USER MANAGEMENT', 'Manage Users')}
              <button onClick={fetchUsers} style={{ padding: '9px 20px', background: 'linear-gradient(135deg,' + gold2 + ',#b8922e)', border: 'none', color: '#000', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '12px', fontWeight: '900', letterSpacing: '1.5px' }}>🔄 REFRESH</button>
            </div>
            <div style={{ marginBottom: '20px' }}>
              <input style={{ ...inputStyle, maxWidth: '400px' }} type="text" placeholder="🔍 Search by name or email..." value={userSearch} onChange={e => setUserSearch(e.target.value)} />
            </div>
            {usersLoading ? (
              <div style={{ textAlign: 'center', padding: '60px', color: muted }}>LOADING USERS...</div>
            ) : (
              <div style={{ background: 'linear-gradient(160deg,#1e0404,#0e0101)', border: '1px solid ' + border, borderRadius: '12px', overflow: 'hidden' }}>
                <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1fr 1fr 1fr', gap: '0', borderBottom: '1px solid ' + border, padding: '12px 20px', background: 'rgba(212,168,67,0.05)' }}>
                  {['NAME', 'EMAIL', 'PLAN', 'ROLE', 'JOINED', 'ACTION'].map(h => (
                    <div key={h} style={{ fontFamily: "'Barlow Condensed', sans-serif", fontSize: '10px', fontWeight: '800', letterSpacing: '2px', color: gold2 }}>{h}</div>
                  ))}
                </div>
                {users.filter(u => { if (!userSearch) return true; const q = userSearch.toLowerCase(); return (u.full_name||'').toLowerCase().includes(q) || (u.email||'').toLowerCase().includes(q); }).map((u, i) => (
                  <div key={u.id} style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 1fr 1fr 1fr 1fr', gap: '0', padding: '14px 20px', borderBottom: '1px solid rgba(212,168,67,0.06)', background: i % 2 === 0 ? 'transparent' : 'rgba(255,255,255,0.01)', alignItems: 'center' }}>
                    <div>
                      <div style={{ color: cream, fontWeight: '600', fontSize: '13px' }}>{u.full_name || '—'}</div>
                      {u.is_superadmin && <span style={{ background: 'rgba(212,168,67,0.15)', color: gold, border: '1px solid rgba(212,168,67,0.3)', padding: '1px 8px', borderRadius: '10px', fontSize: '9px', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800' }}>👑 SUPERADMIN</span>}
                      {u.is_admin && !u.is_superadmin && <span style={{ background: 'rgba(0,168,225,0.15)', color: '#00a8e1', border: '1px solid rgba(0,168,225,0.3)', padding: '1px 8px', borderRadius: '10px', fontSize: '9px', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800' }}>📤 ADMIN</span>}
                    </div>
                    <div style={{ color: cream2, fontSize: '12px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{u.email}</div>
                    <div><span style={{ background: 'rgba(255,255,255,0.05)', color: muted, padding: '2px 8px', borderRadius: '10px', fontSize: '10px' }}>{u.subscription_plan || 'free'}</span></div>
                    <div style={{ color: u.is_superadmin ? gold : u.is_admin ? '#00a8e1' : muted, fontSize: '11px' }}>{u.is_superadmin ? '👑 Super' : u.is_admin ? '📤 Admin' : '👤 User'}</div>
                    <div style={{ color: muted, fontSize: '11px' }}>{u.created_at ? new Date(u.created_at).toLocaleDateString() : '—'}</div>
                    <div>
                      {!u.is_superadmin && (
                        <button onClick={() => handleToggleAdmin(u.id, u.is_admin)} style={{ padding: '5px 12px', background: u.is_admin ? 'rgba(255,68,68,0.1)' : 'rgba(0,212,128,0.1)', border: '1px solid ' + (u.is_admin ? 'rgba(255,68,68,0.35)' : 'rgba(0,212,128,0.35)'), color: u.is_admin ? '#ff6666' : green, borderRadius: '6px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '11px', fontWeight: '700', whiteSpace: 'nowrap' }}>
                          {u.is_admin ? '❌ Remove Admin' : '✅ Make Admin'}
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

      </div>

      {/* WHATSAPP BROADCAST */}
      {activeTab === 'users' && isSuperAdmin && (
        <div style={{margin:'20px 3%',background:'rgba(37,211,102,0.05)',border:'1px solid rgba(37,211,102,0.3)',borderRadius:'12px',padding:'20px'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'16px'}}>
            <div style={{color:'#25d366',fontWeight:900,fontSize:'14px'}}>📱 WHATSAPP BROADCAST LIST</div>
            <div style={{display:'flex',gap:'8px'}}>
              {['all','paid','free'].map(f=>(
                <button key={f} onClick={()=>setWaFilter(f)} style={{padding:'4px 12px',background:waFilter===f?'rgba(37,211,102,0.2)':'transparent',border:'1px solid rgba(37,211,102,0.3)',borderRadius:'4px',color:'#25d366',fontSize:'11px',fontWeight:700,cursor:'pointer'}}>{f.toUpperCase()}</button>
              ))}
              <button onClick={async()=>{
                setWaLoading(true);
                const tok=localStorage.getItem('token');
                const r=await fetch(API_URL+'/api/admin/whatsapp-broadcast',{headers:{Authorization:'Bearer '+tok}});
                const d=await r.json();
                setWaData(d);
                setWaLoading(false);
              }} style={{padding:'4px 12px',background:'linear-gradient(135deg,#25d366,#128c7e)',border:'none',borderRadius:'4px',color:'#fff',fontSize:'11px',fontWeight:700,cursor:'pointer'}}>
                {waLoading?'Loading...':'📥 LOAD LIST'}
              </button>
            </div>
          </div>
          {waData && (
            <div>
              <div style={{color:'rgba(255,255,255,0.4)',fontSize:'11px',marginBottom:'12px'}}>
                Total: {waData.total} | Paid: {(waData.paid||[]).length} | Free: {(waData.free||[]).length}
              </div>
              <textarea readOnly value={(waFilter==='paid'?waData.paid:waFilter==='free'?waData.free:waData.all||[]).map(u=>u.name+' - '+u.email+(u.phone?' - '+u.phone:'')).join('\n')} style={{width:'100%',height:'200px',background:'rgba(0,0,0,0.3)',border:'1px solid rgba(37,211,102,0.2)',borderRadius:'8px',color:'#25d366',fontSize:'11px',padding:'10px',resize:'vertical',boxSizing:'border-box'}}/>
              <button onClick={()=>{
                const list=(waFilter==='paid'?waData.paid:waFilter==='free'?waData.free:waData.all||[]).map(u=>u.name+' - '+u.email+(u.phone?' - '+u.phone:'')).join('\n');
                navigator.clipboard.writeText(list);
                alert('✅ Copied '+list.split('\n').length+' contacts!');
              }} style={{marginTop:'8px',padding:'8px 20px',background:'linear-gradient(135deg,#25d366,#128c7e)',border:'none',borderRadius:'6px',color:'#fff',fontWeight:700,cursor:'pointer',fontSize:'12px'}}>📋 COPY ALL</button>
            </div>
          )}
          {!waData && !waLoading && <div style={{color:'rgba(255,255,255,0.3)',fontSize:'12px'}}>Click "LOAD LIST" to fetch user contacts for WhatsApp broadcast.</div>}
        </div>
      )}

      {/* EDIT MODAL */}
      {editingVideo && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }} onClick={() => setEditingVideo(null)}>
          <div style={{ background: bg2, border: '1px solid ' + border, borderRadius: '16px', padding: '28px', width: '100%', maxWidth: '580px', maxHeight: '90vh', overflowY: 'auto', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', paddingBottom: '16px', borderBottom: '1px solid ' + border }}>
              <h2 style={{ fontFamily: "'Cinzel', serif", fontSize: '1.2em', fontWeight: '900', color: gold, letterSpacing: '2px', margin: 0 }}>Edit Video</h2>
              <button onClick={() => setEditingVideo(null)} style={{ background: 'none', border: 'none', color: muted, cursor: 'pointer', fontSize: '20px' }}>✕</button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
              {[{ lbl: '📝 TITLE *', key: 'title', type: 'text' }, ].map(f => (
                <div key={f.key}>
                  <label style={labelStyle}>{f.lbl}</label>
                  <input style={inputStyle} type={f.type} value={editDetails[f.key] || ''} onChange={e => setEditDetails(p => ({ ...p, [f.key]: e.target.value }))} />
                </div>
              ))}
              <div>
                <label style={labelStyle}>📁 CATEGORY</label>
                <select style={inputStyle} value={editDetails.category || 'Interviews'} onChange={e => setEditDetails(p => ({ ...p, category: e.target.value }))}>
                  {CATS.map(c => <option key={c.v} value={c.v}>{c.l}</option>)}
                </select>
              </div>
              <div>
                <label style={labelStyle}>⏱️ DURATION (seconds)</label>
                <input style={inputStyle} type="number" value={editDetails.duration || 0} onChange={e => setEditDetails(p => ({ ...p, duration: parseInt(e.target.value) }))} />
              </div>
              <div>
                <label style={labelStyle}>📺 SERIES / EPISODE — optional (leave Series ID blank for a standalone video)</label>
                <SeriesPicker value={editDetails.series_id || ''} list={seriesOptions} inputStyle={inputStyle}
                  onChange={v => setEditDetails(p => ({ ...p, series_id: v }))} />
                {(editDetails.series_id || '').trim() && (
                  <div style={{ display: 'flex', gap: '12px', marginTop: '12px' }}>
                    <div style={{ flex: 1 }}>
                      <label style={labelStyle}>SEASON *</label>
                      <input style={inputStyle} type="number" min="1" value={editDetails.season_number || ''} onChange={e => setEditDetails(p => ({ ...p, season_number: e.target.value }))} placeholder="e.g. 1" />
                    </div>
                    <div style={{ flex: 1 }}>
                      <label style={labelStyle}>EPISODE *</label>
                      <input style={inputStyle} type="number" min="1" value={editDetails.episode_number || ''} onChange={e => setEditDetails(p => ({ ...p, episode_number: e.target.value }))} placeholder="e.g. 1" />
                    </div>
                  </div>
                )}
              </div>
              <div>
                <label style={labelStyle}>⭐ CONTENT TYPE</label>
                <div style={{ display: 'flex', gap: '10px', marginTop: '4px' }}>
                  <button type="button" onClick={() => setEditDetails(p => ({ ...p, is_premium: false }))} style={{ flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800', fontSize: '12px', border: '2px solid rgba(0,212,128,0.4)', background: !editDetails.is_premium ? 'rgba(0,212,128,0.15)' : 'transparent', color: !editDetails.is_premium ? green : muted }}>🆓 FREE</button>
                  <button type="button" onClick={() => setEditDetails(p => ({ ...p, is_premium: true }))} style={{ flex: 1, padding: '10px', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontWeight: '800', fontSize: '12px', border: '2px solid rgba(245,200,66,0.4)', background: editDetails.is_premium ? 'rgba(245,200,66,0.12)' : 'transparent', color: editDetails.is_premium ? gold : muted }}>⭐ PREMIUM</button>
                </div>
              </div>
              <div>
                <label style={labelStyle}>📄 DESCRIPTION</label>
                <textarea style={{ ...inputStyle, resize: 'vertical' }} value={editDetails.description || ''} onChange={e => setEditDetails(p => ({ ...p, description: e.target.value }))} rows="3" />
              </div>
              <div>
                <label style={labelStyle}>📝 TRANSCRIPT</label>
                <textarea style={{ ...inputStyle, resize: 'vertical' }} value={editDetails.transcript || ''} onChange={e => setEditDetails(p => ({ ...p, transcript: e.target.value }))} rows="4" />
              </div>
              {editStatus && (
                <div style={{ padding: '12px 16px', borderRadius: '8px', background: editStatus.includes('✅') ? 'rgba(0,212,128,0.08)' : 'rgba(255,68,68,0.08)', color: editStatus.includes('✅') ? green : '#ff6666', fontSize: '13px' }}>
                  {editStatus}
                </div>
              )}
              <div style={{ display: 'flex', gap: '10px' }}>
                <button onClick={handleSaveEdit} disabled={editSaving} style={{ flex: 1, padding: '13px', background: 'linear-gradient(135deg,' + red + ',' + red2 + ')', border: 'none', color: '#fff', borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '14px', fontWeight: '900', letterSpacing: '2px' }}>
                  {editSaving ? '⏳ SAVING...' : '💾 SAVE CHANGES'}
                </button>
                <button onClick={() => setEditingVideo(null)} style={{ padding: '13px 20px', background: 'transparent', border: '1px solid rgba(212,168,67,0.3)', color: gold2, borderRadius: '8px', cursor: 'pointer', fontFamily: "'Barlow Condensed', sans-serif", fontSize: '13px', fontWeight: '700' }}>Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default AdminDashboard;




